import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import moment from "moment";
import DOMPurify from "dompurify";
import { get_ApiManager, post_ApiManager } from "../ApiManager/ApiManager";
import * as FaIcons from "react-icons/fa";
import Modals from "./Modal";
import { apiUrl } from "../ApiManager/AxiosHeaders";

export const withNavigation = (Component: Component) => {
  return (props) => <Component {...props} navigate={useNavigate()} />;
};

class AppsCommission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      savingInstallments: false,
      paymentFile: null,
      fileDrag: false,
      editLoading: false,
      dob: "",
      frequency: "",
      newBonus: "",
      bonusNotes:"",
      courseid: "",
      paymentPlanText: "Add Payment Plan",
      makePlanBtn: false,
      installments: "",
      inst_startdate: "",
      savePlanBtn: false,
      showQuarters: false,
      quartersList: [],
      discountEdit: false,
      commissionEdit: false,
      selectedCourse: [],
      discountEditedValue: "",
      commissionEditedValue: "",
      savePlanBtn: false,
      bonusPaymentid: "",
      appBonus: "",
      bonusId: "",
      bonusCourse: "",
      showCustomPlan: false,
      showAddPayment: false,
      paymentAmount: "",
      paymentDate: "",
      showHistroyBtn: false,
      bonusInstallmentBtn: false,
      totalBonusAmount: "",
      showBonusAddPaymentInput: "",
      remainingBonus: "",
      newFee: "",
      rowEdit: "",
      sEditCommission: "",
      sEditExcl: "",
      sEditIncl: "",
      sEditDiscount: "",
      sEditDiscountIncl: "",
      sEditDiscountExcl: "",
      showNote: false,
      noteId: "",
      showNoteDetail: false,
      noteDetail: "",
      editDueDate: false,
      updatedDueDate: "",
      editingDueDateQtr:"",
      customBonusList: [
        {
          installment: 1,
          duedate: "",
          amount: "",
          amount_error: "",
          duedate_error: "",
        },
      ],
      customPlanList: [
        {
          installment: 1,
          duedate: "",
          applydiscount: false,
          courseid: "",
          clientid: "",
          appid: "",
          amount: "",
          commission: "",
          commissionexcl: "",
          commissionincl: "",
          discount: "",
          discount_incl_gst: "",
          discount_excl_gst: "",
          duedate_error: "",
          amount_error: "",
          paymentdate_error: "",
          bonus_error: "",
          updatedCommissionValue: false,
        },
      ],
      headers: [
        { name: "#", field: "id", align: "text-center", key: 1 },
        { name: "Due Date", align: "text-center", field: "name", key: 2 },
        { name: "Amount", field: "amount", align: "text-center", key: 3 },
        { name: "Com%", field: "commission", align: "text-center", key: 4 },
        {
          name: "Com_Incl",
          field: "commissionincl",
          align: "text-center",
          key: 5,
        },
        {
          name: "Com_Excl",
          field: "commissionexcl",
          align: "text-center",
          key: 6,
        },
        { name: "Discount%", field: "discount", align: "text-center", key: 7 },
        {
          name: "Dis_Incl_Gst",
          field: "discount_incl_gst",
          align: "text-center",
          key: 8,
        },
        {
          name: "Dis_Excl_Gst",
          field: "discount_excl_gst",
          align: "text-center",
          key: 9,
        },
        { name: "Status", field: "status", align: "text-center", key: 10 },
        { name: "Comments", field: "coments", align: "text-center", key: 11 },
        { name: "", field: "", align: "text-center", key: 12 },
      ],
      installmentsHeaders: [
        { name: "#", field: "id", align: "text-center", key: 1 },
        { name: "Due Date", align: "text-center", field: "name", key: 2 },
        { name: "Amount", field: "amount", align: "text-center", key: 3 },
        { name: "Com%", field: "commission", align: "text-center", key: 4 },
        {
          name: "Com_Incl",
          field: "commissionincl",
          align: "text-center",
          key: 5,
        },
        {
          name: "Com_Excl",
          field: "commissionexcl",
          align: "text-center",
          key: 6,
        },
        { name: "Discount%", field: "discount", align: "text-center", key: 7 },
        {
          name: "Dis_Incl_Gst",
          field: "discount_incl_gst",
          align: "text-center",
          key: 8,
        },
        {
          name: "Dis_Excl_Gst",
          field: "discount_excl_gst",
          align: "text-center",
          key: 9,
        },
        {
          name: "Remaining",
          field: "remaining",
          align: "text-center",
          key: 10,
        },
        { name: "Status", field: "status", align: "text-center", key: 11 },

        { name: "Comments", field: "coments", align: "text-center", key: 13 },
        { name: "", field: "", align: "text-center", key: 14 },
      ],
      histroyHeaders: [
        { name: "Paid Date", align: "text-center", field: "name", key: 2 },
        { name: "Paid Amount", field: "amount", align: "text-center", key: 3 },
        { name: "Status", field: "amount", align: "text-center", key: 4 },
        { name: "", field: "", align: "text-center", key: 5 },
      ],
      bonusHeaders: [
        { name: "#", field: "id", align: "text-center", key: 1 },
        { name: "Due Date", align: "text-center", field: "name", key: 2 },
        { name: "Amount", field: "amount", align: "text-center", key: 3 },
        { name: "Status", field: "status", align: "text-center", key: 4 },
        { name: "Payment", field: "", align: "text-center", key: 5 },
      ],
      // New editable fields for course dates
      newStartDate: "",
      newEndDate: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.addPlan = this.addPlan.bind(this);
    this.makePlan = this.makePlan.bind(this);
    this.savePlan = this.savePlan.bind(this);
    this.addNote = this.addNote.bind(this);
    this.handleCommissionChange = this.handleCommissionChange.bind(this);
  }

  handleFileChange = (file) => {
    if (file) {
      // Optional: validate type/size here
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (!allowedTypes.includes(file.type)) {
        alert("Invalid file type. Please upload PDF, JPG, PNG, or DOC/DOCX.");
        return;
      }
    }
    this.setState({ paymentFile: file });
  };

  handleFileDrop = (e) => {
    e.preventDefault();
    this.setState({ fileDrag: false });
    const file = e.dataTransfer.files[0];
    this.handleFileChange(file);
  };

  handleFileDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.fileDrag) {
      this.setState({ fileDrag: true });
    }
  };

  handleFileDragLeave = () => {
    this.setState({ fileDrag: false });
  };

  removeFile = () => {
    this.setState({ paymentFile: null });
  };

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleModal() {
    this.setState({
      makePlanBtn: false,
      installments: "",
      inst_startdate: "",
      showAddPayment: false,
      frequency: "",
      quartersList: [],
      showQuarters: false,
      showAddPayment: false,
      savePlanBtn: false,
      showHistroyBtn: false,
      bonusInstallmentBtn: false,
      paymentPlanText: "Add Payment Plan",
    });
    this.props.parentCallback("cancel");
  }
  saveDob(e) {
    e.preventDefault();
    let url = `saveDob/${this.props.clientDetail["clientid"]}/${this.state.dob}`;
    console.log(url);
    get_ApiManager(
      "",
      url,
      (res) => {
        console.log("saved-dob", res);
        if (res.data.error) swal(" ", res.data.error, "error");
        else {
          swal("Success!", res.data.message, "success");
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  // Add plan
  async addPlan(e, row) {
    e.preventDefault();
    this.setState({
      makePlanBtn: true,
      selectedCourse: row,
      savePlanBtn: false,
      courseid: row.courseid,
      showQuarters: false,
      paymentPlanText: "Add Payment Plan",
      customPlanList: [
        {
          installment: 1,
          duedate: "",
          applydiscount: false,
          courseid: "",
          clientid: "",
          appid: "",
          amount: "",
          commission: "",
          commissionexcl: "",
          commissionincl: "",
          discount: "",
          discount_incl_gst: "",
          discount_excl_gst: "",
          duedate_error: "",
          amount_error: "",
          paymentdate_error: "",
          bonus_error: "",
        },
      ],
      quartersList: [],
      showHistroyBtn: false,
      showCustomPlan: false,
    });
  }
  // Make Payment Plans according to amount given
  async makePlan(e) {
    e.preventDefault();
    if (this.state.frequency === "custom") {
      const customPlanList = [...this.state.customPlanList];

      let existingInstalledAmount = 0;
      if (this.state.selectedCourse.installments) {
            this.state.selectedCourse.installments.forEach(inst => {
                existingInstalledAmount += parseFloat(inst.amount || 0);
            });
        }

     const remainingAmount = parseFloat(this.state.selectedCourse["offered_fee"]) - existingInstalledAmount;

     customPlanList[0]["total"] = remainingAmount; 
        this.setState({
            bonusId: "",
            totalAmount: remainingAmount, 
            remaining: remainingAmount,
            courseid: this.state.selectedCourse["courseid"],
            showCustomPlan: true,
            showQuarters: false,
            makePlanBtn: false,
            showHistroyBtn: false,
            paymentPlanText: "Edit Payment Plan",
            selectedCourse: this.state.selectedCourse["name"],
        });
    } else {
      if (
        this.state.inst_startdate &&
        this.state.frequency &&
        this.state.installments
      ) {
        const frequencyMultiplier = {
          monthly: { unit: "months", value: 1 },
          fortnight: { unit: "days", value: 14 },
          quarterly: { unit: "months", value: 3 },
          halfyearly: { unit: "months", value: 6 },
          annual: { unit: "year", value: 1 },
          custom: { unit: "days", value: 7 }, // Adjust this value as needed
        };

        const installments = this.state.installments;
        const selectedCourse = this.state.selectedCourse;
        const location = this.props.clientDetail["location"];

        const commissionPercent =
          location === "onshore"
            ? selectedCourse["onshore_com"] / 100
            : selectedCourse["offshore_com"] / 100;

        const dateArray = [];

        for (let i = 0; i < installments; i++) {
          const frequencyInfo = frequencyMultiplier[this.state.frequency];
          const futureMonth = moment(this.state.inst_startdate).add(
            i * frequencyInfo.value,
            frequencyInfo.unit
          );

          const dividedAmount = selectedCourse["offered_fee"] / installments;

          const commissionExcl = dividedAmount * commissionPercent;
          const incl = commissionExcl * 0.1;
          const commissionIncl = commissionExcl + incl;
          console.log(installments);
          dateArray.push({
            paymentdate: futureMonth.format("YYYY-MM-D"),
            amount: parseFloat(dividedAmount).toFixed(2),
            qtr: i + 1,
            remaining_amount: parseFloat(dividedAmount).toFixed(2),
            status: "pending",
            commission: commissionPercent,
            courseid: this.state.selectedCourse["courseid"],
            appid: this.state.selectedCourse["appid"],
            clientid: this.state.selectedCourse["clientid"],
            commissionexcl: parseFloat(commissionExcl).toFixed(2),
            commissionincl: parseFloat(commissionIncl).toFixed(2),
            applydiscount: false,
            installment: i + 1,
            duedate: futureMonth,
            discount: "",
            discount_incl_gst: "",
            discount_excl_gst: "",
            discountExcl: "",
          });
        }

        this.setState({
          customPlanList: [
            {
              installment: 1,
              duedate: "",
              applydiscount: false,
              courseid: "",
              clientid: "",
              appid: "",
              amount: "",
              commission: "",
              commissionexcl: "",
              commissionincl: "",
              discount: "",
              discount_incl_gst: "",
              discount_excl_gst: "",
              duedate_error: "",
              amount_error: "",
              paymentdate_error: "",
              bonus_error: "",
            },
          ],
          quartersList: dateArray,
          showQuarters: true,
          makePlanBtn: false,
          paymentPlanText: "Edit Payment Plan",
          savePlanBtn: true,
        });
      } else {
        swal(" ", "Please select Plan Details", "error");
      }
    }
  }
  // onclick apply discount set default discount and payable
  applyDiscount = (clickedRow) => {
    if (this.props.clientDetail["location"] == "onshore") {
      var discount = this.state.selectedCourse["onshore_dis"] / 100;
    } else if (this.props.clientDetail["location"] == "offshore") {
      var discount = this.state.selectedCourse["offshore_dis"] / 100;
    }
    var discount_calculate = clickedRow["amount"] * discount * 1.1;
    var discount_incl_gst = parseFloat(discount_calculate).toFixed(2);
    var discount_calculate = clickedRow["amount"] * discount;
    var discount_excl_gst = parseFloat(discount_calculate).toFixed(2);
    const updatedList = this.state.quartersList.map((x) =>
      x.qtr === clickedRow.qtr
        ? {
            ...x,
            applydiscount: true,
            discount: discount,
            discount_incl_gst: discount_incl_gst,
            discount_excl_gst: discount_excl_gst,
          }
        : x
    );
    this.setState({ quartersList: updatedList });
  };
  // onclick apply discount calculate new discount and payable
  handleDiscountChange = (e, clickedRow, index) => {
    e.preventDefault();
    var discount_calculate_incl =
      clickedRow["amount"] * this.state.discountEditedValue * 1.1;
    var discount_incl_gst = parseFloat(discount_calculate_incl).toFixed(2);
    var discount_calculate_excl =
      clickedRow["amount"] * this.state.discountEditedValue;
    var discount_excl_gst = parseFloat(discount_calculate_excl).toFixed(2);
    if (this.state.frequency === "custom") {
      const list = [...this.state.customPlanList];
      list[index]["discount"] = this.state.discountEditedValue;
      list[index]["discount_incl_gst"] = discount_incl_gst;
      list[index]["discount_excl_gst"] = discount_excl_gst;
      list[index]["updatedDiscountValue"] = true;
      list[index]["applydiscount"] = true;
      this.setState({ customPlanList: list });
    } else {
      const updatedList = this.state.quartersList.map((x) =>
        x.qtr === clickedRow.qtr
          ? {
              ...x,
              applydiscount: true,
              discount: this.state.discountEditedValue,
              discount_incl_gst: discount_incl_gst,
              discount_excl_gst: discount_excl_gst,
              updatedDiscountValue: true,
            }
          : x
      );
      this.setState({ quartersList: updatedList });
    }
  };
  // onclick enable apply dicount button
  handleDiscountValue = (e, clickedRow, index) => {
    e.preventDefault();
    let disValue = e.target.value / 100;
    this.setState({ discountEditedValue: disValue });
    if (this.state.frequency === "custom") {
      const list = [...this.state.customPlanList];
      list[index]["updatedDiscountValue"] = false;
      this.setState({ customPlanList: list });
    } else {
      const updatedList = this.state.quartersList.map((x) =>
        x.qtr === clickedRow.qtr
          ? { ...x, updatedDiscountValue: false, updatedCommissionValue: true }
          : x
      );
      this.setState({ quartersList: updatedList });
    }
  };
  // onclick enable apply commission button
  handleCommissionValue = (e, clickedRow, index) => {
    e.preventDefault();
    let value = e.target.value / 100;
    this.setState({ commissionEditedValue: value });
    if (this.state.frequency === "custom") {
      const list = [...this.state.customPlanList];
      list[index]["updatedCommissionValue"] = false;
      this.setState({ customPlanList: list });
    } else {
      const updatedList = this.state.quartersList.map((x) =>
        x.qtr === clickedRow.qtr ? { ...x, updatedCommissionValue: false } : x
      );
      this.setState({ quartersList: updatedList });
    }
  };
  // onclick apply discount calculate new discount and payable
  handleCommissionChange = (e, clickedRow, index) => {
    e.preventDefault();
    let commission = "";
    let commissionexcl = "";
    let commissionincl = "";
    commission = this.state.commissionEditedValue * 100;
    commissionexcl = (clickedRow["amount"] * commission) / 100;
    var incl = commissionexcl * 0.1;
    commissionincl = commissionexcl + incl;
    commission = commission / 100;
    if (this.state.frequency === "custom") {
      const list = [...this.state.customPlanList];
      list[index]["commission"] = commission;
      list[index]["commissionexcl"] = parseFloat(commissionexcl).toFixed(2);
      list[index]["commissionincl"] = parseFloat(commissionincl).toFixed(2);
      list[index]["updatedCommissionValue"] = true;
      this.setState({ customPlanList: list });
    } else {
      const updatedList = this.state.quartersList.map((x) =>
        x.qtr === clickedRow.qtr
          ? {
              ...x,
              commission: commission,
              commissionexcl: parseFloat(commissionexcl).toFixed(2),
              commissionincl: parseFloat(commissionincl).toFixed(2),
              updatedCommissionValue: true,
            }
          : x
      );
      this.setState({ quartersList: updatedList });
    }
  };
  handleEditCommissionValue = (e, clickedRow) => {
    e.preventDefault();
    let value = e.target.value / 100;
    let commission = "";
    let commissionexcl = "";
    let commissionincl = "";
    commission = value * 100;
    commissionexcl = (clickedRow["amount"] * commission) / 100;
    var incl = commissionexcl * 0.1;
    commissionincl = commissionexcl + incl;
    commission = commission / 100;
    commissionexcl = parseFloat(commissionexcl).toFixed(2);
    commissionincl = parseFloat(commissionincl).toFixed(2);
    this.setState({
      sEditCommission: commission,
      sEditIncl: commissionincl,
      sEditExcl: commissionexcl,
    });
  };
  // onclick enable apply dicount button
  handleDiscountEditValue = (e, clickedRow, index) => {
    e.preventDefault();
    let disValue = e.target.value / 100;
    var discount_calculate_incl = clickedRow["amount"] * disValue * 1.1;
    var discount_calculate_excl = clickedRow["amount"] * disValue;
    var discount_incl_gst = parseFloat(discount_calculate_incl).toFixed(2);
    var discount_excl_gst = parseFloat(discount_calculate_excl).toFixed(2);
    this.setState({
      sEditDiscount: disValue,
      sEditDiscountIncl: discount_incl_gst,
      sEditDiscountExcl: discount_excl_gst,
    });
  };
saveDueDate = (e, item) => {
  e.preventDefault();
  this.setState({ editingDueDateQtr: null });
};
  // handle apply due data
 handleDueDateChange = (e, clickedRow) => {
  const newDate = e.target.value; 
  
  this.setState((prevState) => ({
    quartersList: prevState.quartersList.map((item) =>
      item.qtr === clickedRow.qtr
        ? { ...item, paymentdate: newDate } 
        : item
    ),
    editingDueDateQtr: clickedRow.qtr,
  }));
};

  formatDateForInput = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ""; 
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

  // save plans
  async savePlan(e, courseid) {
    e.preventDefault();
    let check = 1;
    if (this.state.frequency === "custom") {
      this.state.customPlanList.map((v) => {
        if (!v.paymentdate || !v.amount) {
          swal("", "payment date or amount is empty", "error");
          check = 0;
          return check;
        }
      });
    }
    if (check === 1) {
      const data = {
        appid: this.props.appid,
        courseid: courseid,
        commissionList:
          this.state.frequency === "custom"
            ? this.state.customPlanList
            : this.state.quartersList,
      };
      console.log(data);
      let url = "commission";
      console.log(data);
      post_ApiManager(
        data,
        url,
        (res) => {
          console.log("commission-added", res);
          if (res.data.error) {
            swal(" ", res.data.error, "error");
          } else {
            this.props.parentCallback("getInstallments");
            this.setState({
              courseid: "",
              showInstallmentPlan: false,
              showCustomPlan: false,
              showQuarters: false,
              makePlanBtn: false,
              savePlanBtn: false,
              quartersList: [],
              showHistroyBtn: false,
              customPlanList: [
                {
                  installment: 1,
                  duedate: "",
                  applydiscount: false,
                  courseid: "",
                  clientid: "",
                  appid: "",
                  amount: "",
                  commission: "",
                  commissionexcl: "",
                  commissionincl: "",
                  discount: "",
                  discount_incl_gst: "",
                  discount_excl_gst: "",
                  duedate_error: "",
                  amount_error: "",
                  paymentdate_error: "",
                },
              ],
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }
  // For custom plan
  handleCustomInputChange(e, index, row) {
    e.preventDefault();
    const { name, value } = e.target;
    const list = [...this.state.customPlanList];
    list[index]["duedate_error"] = "";
    list[index]["amount_error"] = "";
    list[index]["bonus_error"] = "";
    console.log(name);
    console.log(value);
    if (name === "duedate") {
      list[index]["duedate"] = value;
      this.setState({ customPlanList: list });
    } else if (name === "amount" && !list[index]["duedate"]) {
      list[index]["duedate_error"] = "Please enter payment date";
      list[index]["amount"] = 0.0;
      this.setState({ customPlanList: list });
    } else if (name === "amount" && list[index]["duedate"]) {
      list[index]["amount"] = 0.0;
      list[index][name] = value;
      list[index]["courseid"] = row.courseid;
      list[index]["clientid"] = row.clientid;
      list[index]["appid"] = row.appid;
      if (this.props.clientDetail["location"] == "onshore") {
        list[index]["commission"] = row.onshore_com / 100;
        list[index]["commissionexcl"] =
          (list[index]["amount"] * row.onshore_com) / 100;
      } else if (this.props.clientDetail["location"] == "offshore") {
        list[index]["commission"] = row.offshore_com / 100;
        list[index]["commissionexcl"] =
          (list[index]["amount"] * row.offshore_com) / 100;
      }
      var incl = list[index]["commissionexcl"] * 0.1;
      list[index]["commissionincl"] = list[index]["commissionexcl"] + incl;
      list[index]["commissionEdit"] = false;
      let totalArray = [];
      this.state.customPlanList.map((x) => {
        return totalArray.push(Math.fround(x.amount));
      });
      let sum = totalArray.reduce((a, v) => (a = a + v), 0.0);
      sum = parseFloat(sum).toFixed(2);
      let total = this.state.totalAmount - parseFloat(sum).toFixed(2);
      this.setState({ customPlanList: list, remaining: total });
    } else if (name === "applydiscount" && !list[index]["amount"]) {
      list[index]["amount_error"] = "Please enter amount";
      this.setState({ customPlanList: list });
    } else if (name === "applydiscount" && list[index]["amount"]) {
      if (list[index]["applydiscount"] == false) {
        list[index]["applydiscount"] = true;
        if (this.props.clientDetail["location"] == "onshore") {
          list[index]["discount"] = row.onshore_dis / 100;
          var discount = list[index]["amount"] * list[index]["discount"] * 1.1;
          list[index]["discount_incl_gst"] = parseFloat(discount).toFixed(2);
          var discountexcl = list[index]["amount"] * list[index]["discount"];
          list[index]["discount_excl_gst"] =
            parseFloat(discountexcl).toFixed(2);
        } else if (this.props.clientDetail["location"] == "offshore") {
          list[index]["discount"] = row.offshore_dis / 100;
          var discount = list[index]["amount"] * list[index]["discount"] * 1.1;
          list[index]["discount_incl_gst"] = parseFloat(discount).toFixed(2);
          var discountexcl = list[index]["amount"] * list[index]["discount"];
          list[index]["discount_excl_gst"] =
            parseFloat(discountexcl).toFixed(2);
        }
      } else {
        list[index]["applydiscount"] = false;
      }
      this.setState({ customPlanList: list });
    }
  }
  // For installment custom plan
  handleCustomAddClick(i, e) {
    e.preventDefault();
    const customList = [...this.state.customPlanList];
    customList[i]["amount_error"] = "";
    if (!customList[i]["duedate"]) {
      customList[i]["duedate_error"] = "Please enter payment date";
      this.setState({ customPlanList: customList });
    } else if (!customList[i]["amount"]) {
      customList[i]["amount_error"] = "Please enter amount";
      this.setState({ customPlanList: customList });
    } else {
      this.setState({
        customPlanList: [
          ...this.state.customPlanList,
          {
            installment: this.state.customPlanList.length + 1,
            duedate: "",
            applydiscount: false,
            courseid: "",
            clientid: "",
            appid: "",
            amount: "",
            commission: "",
            commissionexcl: "",
            commissionincl: "",
            discount: "",
            discount_incl_gst: "",
            discount_excl_gst: "",
            duedate_error: "",
            amount_error: "",
            paymentdate_error: "",
            bonus_error: "",
          },
        ],
      });
    }
  }
  // For intallement remove custom plan
  handleCustomRemoveClick(e, i) {
    e.preventDefault();
    const list = [...this.state.customPlanList];
    list.splice(i, 1);
    this.setState({ customPlanList: list }, () => {
      let totalArray = [];
      this.state.customPlanList.map((x) => {
        return totalArray.push(Math.fround(x.amount));
      });
      let sum = totalArray.reduce((a, v) => (a = a + v), 0.0);
      sum = parseFloat(sum).toFixed(2);
      let total = this.state.totalAmount - parseFloat(sum).toFixed(2);
      this.setState({ remaining: total });
    });
  }
  allowCommissionEdit(e, clickedRow) {
    e.preventDefault();
    const updatedList = this.state.customPlanList.map((x) =>
      x.qtr === clickedRow.qtr ? { ...x, commissionEdit: true } : x
    );
    this.setState({ customPlanList: updatedList });
  }
  allowDiscountEdit(e, clickedRow) {
    e.preventDefault();
    const updatedList = this.state.customPlanList.map((x) =>
      x.qtr === clickedRow.qtr ? { ...x, discountEdit: true } : x
    );
    this.setState({ customPlanList: updatedList });
  }
  // save bonus updated value
  saveBonus(e, v) {
    e.preventDefault();
    let new_bonus = "0";
    if (this.state.bonusId === "other") {
      new_bonus = this.state.newBonus;
    }

    const url = "saveBonus";
    const body = {
    bonusId: this.state.bonusId,
    courseid: v.courseid,
    new_bonus: new_bonus,
    appid: this.props.appid,
    notes: this.state.bonusNotes,
    };

    post_ApiManager(
    body,
    url,
    (res) => {
      if (res.data.error) {
        swal(" ", res.data.error, "error");
      } else {
        swal("Success!", res.data.message, "success");
        this.props.parentCallback("getInstallments");
        this.setState({
          showBonusInstallment: false,
          appBonus: "",
          bonusNotes: "",
          newBonus: ""
        });
      }
    },
    (err) => {
      console.log(err);
    }
  );
  }
  bonusValue(e, bonusid, appbonus) {
    e.preventDefault();
    this.setState({ bonusId: bonusid, appBonus: appbonus });
  }
  saveInstallments(e, courseid) {
    e.preventDefault();

    const dates = this.state.customPlanList.map((item) => item.duedate);
    const hasDuplicateDates = new Set(dates).size !== dates.length;

    if (hasDuplicateDates) {
      swal(
        "Error",
        "Duplicate payment dates found. Please ensure all installments have unique dates.",
        "error"
      );
      return;
    }

    let totalArray = [];
    this.state.customPlanList.map((x) => {
      return totalArray.push(Math.fround(x.amount));
    });
    let sum = totalArray.reduce((a, v) => (a = a + v), 0.0);

      if (sum > this.state.totalAmount) {
        swal("Error", "Installment amount exceeds the remaining course fee", "error");
        return; 
    }
    if (sum <= 0) {
        swal("Error", "Please enter a valid amount", "error");
        return;
    }

   this.setState({ savingInstallments: true });
      const data = {
        commissionList: this.state.customPlanList,
        type: this.props.type,
        courseid: courseid,
      };
      let url = "commission";
      console.log(data);
      post_ApiManager(
        data,
        url,
        (res) => {
          this.setState({ savingInstallments: false });
          console.log("commission-added", res);
          if (res.data.error) {
            swal(" ", res.data.error, "error");
          } else {
            this.props.parentCallback("getInstallments");
            this.setState({
              courseid: "",
              showHistroyBtn: false,
              showInstallmentPlan: false,
              customPlanList: [
                {
                  installment: 1,
                  duedate: "",
                  applydiscount: false,
                  courseid: "",
                  clientid: "",
                  appid: "",
                  amount: "",
                  commission: "",
                  commissionexcl: "",
                  commissionincl: "",
                  discount: "",
                  discount_incl_gst: "",
                  discount_excl_gst: "",
                  duedate_error: "",
                  amount_error: "",
                  paymentdate_error: "",
                },
              ],
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }
  deleteInstallments(e, courseid, id) {
    e.preventDefault();
    swal({
      title: "Are you sure?",
      text: "You want to delete installments",
      icon: "warning",
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        let url = `deleteCommissionsInstallments/${courseid}/${this.props.appid}/${this.props.type}/${id}`;
        console.log(url);
        get_ApiManager(
          "",
          url,
          (res) => {
            console.log("deleted", res);
            if (res.data.error) swal(" ", res.data.error, "error");
            else {
              swal("Success!", res.data.message, "success");
              this.setState({
                showHistroyBtn: false,
                courseid: "",
                customPlanList: [
                  {
                    installment: 1,
                    duedate: "",
                    applydiscount: false,
                    courseid: "",
                    clientid: "",
                    appid: "",
                    amount: "",
                    commission: "",
                    commissionexcl: "",
                    commissionincl: "",
                    discount: "",
                    discount_incl_gst: "",
                    discount_excl_gst: "",
                    duedate_error: "",
                    amount_error: "",
                    paymentdate_error: "",
                  },
                ],
              });
              this.props.parentCallback("getInstallments");
            }
          },
          (err) => {
            console.log(err);
          }
        );
      }
    });
  }
  // Add Payment
  addPayment(e) {
    e.preventDefault();
    this.setState({
      showAddPayment: true,
      makePlanBtn: false,
      showDetail: false,
    });
  }
  //  Make Plan Pyment
  //   async makePayment(e, courseid) {
  //     e.preventDefault();
  //     if (!this.state.paymentDate) {
  //       swal("Please enter payment date");
  //     } else if (!this.state.paymentAmount) {
  //       swal("Please enter payment amount");
  //     } else {
  //       const data = {
  //         courseid: courseid,
  //         appid: this.props.appid,
  //         amount: this.state.paymentAmount,
  //         type: this.props.type,
  //         date: this.state.paymentDate,
  //       };
  //       let url = "saveCommission";
  //       console.log(data);
  //       post_ApiManager(
  //         data,
  //         url,
  //         (res) => {
  //           console.log("commission-saved", res);
  //           if (res.data.error) {
  //             swal(" ", res.data.error, "error");
  //           } else {
  //             swal("Success!", res.data.message, "success");
  //             this.setState({
  //               showHistroyBtn: false,
  //               showAddPayment: false,
  //               paymentAmount: "",
  //               paymentAmount: "",
  //               showDetail: false,
  //             });
  //             this.props.parentCallback("getInstallments");
  //           }
  //         },
  //         (err) => {
  //           console.log(err);
  //         }
  //       );
  //     }
  //   }

  async makePayment(e, courseid) {
    e.preventDefault();

    const { paymentDate, paymentAmount, paymentFile } = this.state;

    if (!paymentDate)
      return swal("Error", "Please enter payment date", "error");
    if (!paymentAmount || parseFloat(paymentAmount) <= 0)
      return swal("Error", "Please enter a valid payment amount", "error");

    const formData = new FormData();
    formData.append("courseid", courseid);
    formData.append("appid", this.props.appid);
    formData.append("amount", paymentAmount);
    formData.append("type", this.props.type);
    formData.append("date", paymentDate);

    if (paymentFile) {
      formData.append("document", paymentFile);
    }

    this.setState({ editLoading: true });

    try {
      let url = "saveCommission";
      const response = await apiUrl.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response) {
        this.setState({
          editLoading: false,
          showAddPayment: false,
          paymentAmount: "",
          paymentDate: "",
          paymentFile: null,
        });
        swal(
          "Success!",
          response.data.message || "Payment recorded",
          "success"
        );
        this.props.parentCallback("getInstallments");
      }
      //   post_ApiManager(
      //     formData,
      //     url,
      //     (res) => {
      //       this.setState({
      //         editLoading: false,
      //         showAddPayment: false,
      //         paymentAmount: "",
      //         paymentDate: "",
      //         paymentFile: null,
      //       });
      //       swal("Success!", res.data.message || "Payment recorded", "success");
      //       this.props.parentCallback("getInstallments");
      //     },
      //     (err) => {
      //       this.setState({ editLoading: false });
      //       console.error("API error:", err);
      //       swal(
      //         "Error",
      //         err.response?.data?.error || "Failed to save payment",
      //         "error"
      //       );
      //     }
      //   );
    } catch (error) {
      this.setState({ editLoading: false });
      console.error("Unexpected error:", error);
      swal("Error", "An unexpected error occurred", "error");
    }
  }
  getHistroy(e, courseid) {
    e.preventDefault();
    let url = `getCommissionHistroy/${courseid}/${this.props.appid}`;
    console.log(url);
    get_ApiManager(
      "",
      url,
      (res) => {
        console.log("histroy", res);
        this.setState({
          historyList: res.data["data"],
          showHistroyBtn: true,
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }
  // showBonusInstallment(e, v) {
  //   e.preventDefault();
  //   console.log(v);
  //   let bonusAmount = v.app_bonus === "other" ? v.new_app_bonus : v.app_bonus;
  //   this.setState({
  //     bonusCourse: v.id,
  //     bonusInstallmentBtn: true,
  //     totalBonusAmount: bonusAmount,
  //     remainingBonus: bonusAmount,
  //   });
  // }
  showBonusInstallment(e, v) {
    e.preventDefault();
    console.log(v);
    let bonusAmount = v.app_bonus === "other" ? v.new_app_bonus : v.app_bonus;
    this.setState({
      bonusCourse: v.courseid,
      bonusInstallmentBtn: true,
      totalBonusAmount: bonusAmount,
      remainingBonus: bonusAmount,
      customBonusList: [
        {
          installment: 1, // This is correct - first installment
          duedate: "",
          amount: "",
          amount_error: "",
          duedate_error: "",
        },
      ],
    });
  }
  cancelBonusInstallment(e) {
    e.preventDefault();
    this.setState({
      bonusInstallmentBtn: false,
      bonusCourse: "",
      customBonusList: [
        {
          installment: 1,
          duedate: "",
          amount: "",
          amount_error: "",
          duedate_error: "",
        },
      ],
    });
  }
  // saveBonusInstallments(e) {
  //   e.preventDefault();
  //   let totalArray = [];
  //   this.state.customBonusList.map((x) => {
  //     return totalArray.push(Math.fround(x.amount));
  //   });
  //   let sum = totalArray.reduce((a, v) => (a = a + v), 0.0);
  //   if (sum != this.state.totalBonusAmount) {
  //     swal("Error", "Please make installments equal to total amount", "error");
  //   } else {
  //     const data = {
  //       bonusList: this.state.customBonusList,
  //       type: this.props.type,
  //       appid: this.props.appid,
  //       courseid: this.state.bonusCourse,
  //     };
  //     console.log(data);
  //     let url = "saveBonusList";
  //     console.log(data);
  //     post_ApiManager(
  //       data,
  //       url,
  //       (res) => {
  //         console.log("bonus added", res);
  //         if (res.data.error) {
  //           swal(" ", res.data.error, "error");
  //         } else {
  //           this.props.parentCallback("getInstallments");
  //           this.setState({
  //             bonusCourse: "",
  //             bonusInstallmentBtn: false,
  //             customBonusList: [
  //               {
  //                 installment: 1,
  //                 duedate: "",
  //                 amount: "",
  //                 amount_error: "",
  //                 duedate_error: "",
  //               },
  //             ],
  //           });
  //         }
  //       },
  //       (err) => {
  //         console.log(err);
  //       }
  //     );
  //   }
  // }
  saveBonusInstallments(e) {
    e.preventDefault();

    // Check for duplicate dates
    const dates = this.state.customBonusList.map((item) => item.duedate);
    const hasDuplicateDates = new Set(dates).size !== dates.length;

    if (hasDuplicateDates) {
      swal(
        "Error",
        "Duplicate payment dates found. Please ensure all bonus installments have unique dates.",
        "error"
      );
      return;
    }

    let totalArray = [];
    this.state.customBonusList.forEach((x) => {
      return totalArray.push(Math.fround(x.amount));
    });
    let sum = totalArray.reduce((a, v) => (a = a + v), 0.0);

    if (Math.abs(sum - this.state.totalBonusAmount) > 0.01) {
      swal(
        "Error",
        "Please make bonus installments equal to total bonus amount",
        "error"
      );
    } else {
      const data = {
        bonusList: this.state.customBonusList,
        type: this.props.type,
        appid: this.props.appid,
        courseid: this.state.bonusCourse, // This should now be 8152
      };

      console.log(
        "Saving bonus installments with courseid:",
        this.state.bonusCourse
      );
      console.log("Full data:", data);

      let url = "saveBonusList";

      post_ApiManager(
        data,
        url,
        (res) => {
          console.log("bonus added", res);
          if (res.data.error) {
            swal(" ", res.data.error, "error");
          } else {
            this.props.parentCallback("getInstallments");
            this.setState({
              bonusCourse: "",
              bonusInstallmentBtn: false,
              customBonusList: [
                {
                  installment: 1,
                  duedate: "",
                  amount: "",
                  amount_error: "",
                  duedate_error: "",
                },
              ],
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }
  // For bonus custom plan
  handleCustomBonusInputChange(e, index) {
    e.preventDefault();
    const { name, value } = e.target;
    const list = [...this.state.customBonusList];
    list[index]["duedate_error"] = "";
    list[index]["amount_error"] = "";
    console.log(name);
    console.log(value);
    if (name === "duedate") {
      list[index]["duedate"] = value;
      this.setState({ customBonusList: list });
    } else if (name === "amount" && !list[index]["duedate"]) {
      list[index]["duedate_error"] = "Please enter payment date";
      list[index]["amount"] = 0.0;
      this.setState({ customBonusList: list });
    } else if (name == "amount" && value < 0) {
      list[index]["amount_error"] = "Please enter amount more than 0";
      this.setState({ customBonusList: list });
    } else {
      list[index][name] = value;
      this.setState({ customBonusList: list });
      let totalArray = [];
      this.state.customBonusList.map((x) => {
        return totalArray.push(Math.fround(x.amount));
      });
      let sum = totalArray.reduce((a, v) => (a = a + v), 0.0);
      sum = parseFloat(sum).toFixed(2);
      let total = this.state.totalBonusAmount - parseFloat(sum).toFixed(2);
      this.setState({ customBonusList: list, remainingBonus: total });
    }
  }
  // For bonus custom plan
  // handleCustomBonusRemoveClick(e, i) {
  //   e.preventDefault();
  //   const list = [...this.state.customBonusList];
  //   list.splice(i, 1);
  //   this.setState({ customBonusList: list }, () => {
  //     let totalArray = [];
  //     this.state.customBonusList.map((x) => {
  //       return totalArray.push(Math.fround(x.amount));
  //     });
  //     let sum = totalArray.reduce((a, v) => (a = a + v), 0.0);
  //     sum = parseFloat(sum).toFixed(2);
  //     let total = this.state.totalBonusAmount - parseFloat(sum).toFixed(2);
  //     this.setState({ remainingBonus: total });
  //   });
  // }
  // For bonus custom plan remove - FIXED
  handleCustomBonusRemoveClick(e, i) {
    e.preventDefault();
    const list = [...this.state.customBonusList];
    list.splice(i, 1);

    // Renumber all installments after removal
    const renumberedList = list.map((item, index) => ({
      ...item,
      installment: index + 1, // Renumber to 1, 2, 3...
    }));

    this.setState({ customBonusList: renumberedList }, () => {
      let totalArray = [];
      renumberedList.forEach((x) => {
        return totalArray.push(Math.fround(x.amount));
      });
      let sum = totalArray.reduce((a, v) => (a = a + v), 0.0);
      sum = parseFloat(sum).toFixed(2);
      let total = this.state.totalBonusAmount - parseFloat(sum).toFixed(2);
      this.setState({ remainingBonus: total });
    });
  }
  // For bonus custom plan
  // handleCustomBonusAddClick(i, e) {
  //   const customList = [...this.state.customBonusList];
  //   customList[i]["amount_error"] = "";
  //   if (!customList[i]["duedate"]) {
  //     customList[i]["duedate_error"] = "Please enter payment date";
  //     this.setState({ customBonusList: customList });
  //   } else if (!customList[i]["amount"]) {
  //     customList[i]["amount_error"] = "Please enter amount";
  //     this.setState({ customBonusList: customList });
  //   } else {
  //     this.setState({
  //       customBonusList: [
  //         ...this.state.customBonusList,
  //         {
  //           installment: 1,
  //           duedate: "",
  //           amount: "",
  //           amount_error: "",
  //           duedate_error: "",
  //         },
  //       ],
  //     });
  //   }
  // }
  // For bonus custom plan
  // For bonus custom plan - FIXED
  handleCustomBonusAddClick(i, e) {
    e.preventDefault();
    const customList = [...this.state.customBonusList];
    customList[i]["amount_error"] = "";

    if (!customList[i]["duedate"]) {
      customList[i]["duedate_error"] = "Please enter payment date";
      this.setState({ customBonusList: customList });
    } else if (!customList[i]["amount"]) {
      customList[i]["amount_error"] = "Please enter amount";
      this.setState({ customBonusList: customList });
    } else {
      // Get the next installment number (current length + 1)
      const nextInstallmentNumber = this.state.customBonusList.length + 1;

      this.setState({
        customBonusList: [
          ...this.state.customBonusList,
          {
            installment: nextInstallmentNumber, // This fixes: 1, 2, 3...
            duedate: "",
            amount: "",
            amount_error: "",
            duedate_error: "",
          },
        ],
      });
    }
  }
  deleteBonusInstallments(e, courseid) {
    e.preventDefault();
    swal({
      title: "Are you sure?",
      text: "You want to delete installments",
      icon: "warning",
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        // Use the courseid parameter, not v.courseid
        let url = `deleteBonusInstallments/${courseid}/${this.props.appid}`;
        console.log("Deleting bonus installments for courseid:", courseid);
        get_ApiManager(
          "",
          url,
          (res) => {
            console.log("deleted", res);
            if (res.data.error) swal(" ", res.data.error, "error");
            else {
              swal("Success!", res.data.message, "success");
              this.setState({
                customBonusList: [
                  {
                    installment: 1,
                    duedate: "",
                    amount: "",
                    amount_error: "",
                    duedate_error: "",
                  },
                ],
              });
              this.props.parentCallback("getInstallments");
            }
          },
          (err) => {
            console.log(err);
          }
        );
      }
    });
  }
  makeBonusPayment(e, id) {
    e.preventDefault();
    this.setState({ showBonusAddPaymentInput: true, bonusPaymentid: id });
  }
  saveBonusPayment(e, id, amount) {
    e.preventDefault();
    if (!this.state.paymentDate) {
      swal("", "Please enter payment date", "error");
    } else if (!this.state.paymentAmount) {
      swal("", "Please enter payment amount", "error");
    } else if (amount != this.state.paymentAmount) {
      swal(
        "",
        "Please enter payment amount equal to installment amount",
        "error"
      );
    } else {
      const data = {
        id: id,
        amount: this.state.paymentAmount,
        type: this.props.type,
        date: this.state.paymentDate,
        appid: this.props.appid,
      };
      let url = "saveBonusPayment";
      console.log(data);
      post_ApiManager(
        data,
        url,
        (res) => {
          console.log("bonus-payment", res);
          if (res.data.error) {
            swal(" ", res.data.error, "error");
          } else {
            this.setState({
              paymentAmount: "",
              paymentDate: "",
              showInstallmentPlan: false,
              customBonusList: [],
              showBonusAddPaymentInput: false,
              bonusPaymentid: "",
            });
            this.props.parentCallback("getInstallments");
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }
  cancelPayment(e) {
    e.preventDefault();
    this.setState({
      showAddPaymentInput: false,
      paymentid: "",
      bonusPaymentid: "",
    });
  }
  updateFee(e, courseid) {
    e.preventDefault();
    swal({
      title: "Are you sure?",
      text: "Provider tution fee, commence date and finish date will be updated!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const data = {
          type: this.props.type,
          newAmount: this.state.newFee,
          newStartDate: this.state.newStartDate,
          newEndDate: this.state.newEndDate,
          appid: this.props.appid,
          courseid: courseid,
          clientid: this.props.clientDetail["clientid"],
        };
        let url = "updateCourseFee";
        console.log(data);
        post_ApiManager(
          data,
          url,
          (res) => {
            console.log("fee", res);
            if (res.data.error) {
              swal(" ", res.data.error, "error");
            } else {
              swal("Success!", res.data.message, "success");
              this.props.parentCallback("getInstallments");
              this.setState({
                newFee: "",
                newStartDate: "",
                newEndDate: "",
              });
            }
          },
          (err) => {
            console.log(err);
          }
        );
      }
    });
  }
  editRow(e, v) {
    e.preventDefault();
    this.setState({ rowEdit: v.id });
  }
  updateSingleRow(e) {
    e.preventDefault();
    const data = {
      editId: this.state.rowEdit,
      newCommission: this.state.sEditCommission,
      newIncl: this.state.sEditIncl,
      newExcl: this.state.sEditExcl,
      newDiscount: this.state.sEditDiscount,
      newDiscountIncl: this.state.sEditDiscountIncl,
      newDiscountExcl: this.state.sEditDiscountExcl,
    };
    console.log(data);
    let url = "updateInstallment";
    post_ApiManager(
      data,
      url,
      (res) => {
        console.log("commission-added", res);
        if (res.data.error) {
          swal(" ", res.data.error, "error");
        } else {
          this.props.parentCallback("getInstallments");
          this.setState({
            rowEdit: "",
            sEditCommission: "",
            sEditExcl: "",
            sEditIncl: "",
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  showNote(e, row) {
    e.preventDefault();
    this.setState({ showNote: true, noteId: row.id });
  }
  handleNoteModelCallback = (check, type, note) => {
    if (type === "edit") {
      this.addNote(note);
    }
    this.setState({ showNote: false });
  };
  addNote(note) {
    const data = {
      editId: this.state.noteId,
      note: note,
    };
    console.log(data);
    let url = "addInstallmentNote";
    post_ApiManager(
      data,
      url,
      (res) => {
        console.log("instal-note", res);
        if (res.data.error) {
          swal(" ", res.data.error, "error");
        } else {
          this.props.parentCallback("getInstallments");
          this.setState({ noteId: "", showNote: false });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  showNoteDetails(e, row) {
    e.preventDefault();
    this.setState({ showNoteDetail: true, noteDetail: row.notes });
  }
  // Delete specific payment history
  async handleDelete(e, id) {
    e.preventDefault();
    let url = `deleteCommissionPayment/${id}`;
    console.log(url);
    get_ApiManager(
      "",
      url,
      (res) => {
        console.log("delete", res);
        if (res.data.error) swal(" ", res.data.error, "error");
        else {
          this.setState({ showHistroyBtn: false });
          this.props.parentCallback("getInstallments");
          swal(" ", res.data.message, "success");
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  // delete single installment
  deleteSingleInstallment = (e, installmentId, courseid) => {
    e.preventDefault();
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this installment!",
      icon: "warning",
      buttons: ["Cancel", "Yes, delete it!"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = `deleteSingleInstallment/${installmentId}/${courseid}/${this.props.appid}/${this.props.type}`;
        get_ApiManager(
          "",
          url,
          (res) => {
            if (res.data.error) {
              swal("Error", res.data.error, "error");
            } else {
              swal("Deleted!", res.data.message, "success");
              this.props.parentCallback("getInstallments");
            }
          },
          (err) => {
            console.error(err);
            swal("Error", "Something went wrong", "error");
          }
        );
      }
    });
  };

  // cancel bonus installment
  cancelBonusInstallment(e) {
  e.preventDefault();
  this.setState({
    bonusInstallmentBtn: false,
    bonusCourse: "",
    customBonusList: [
      {
        installment: 1,
        duedate: "",
        amount: "",
        amount_error: "",
        duedate_error: "",
      },
    ],
  });
}

// cancel make payment
cancelMakePlan(e) {
  e.preventDefault();
  this.setState({
    makePlanBtn: false,
    frequency: "",
    installments: "",
    inst_startdate: "",
    showQuarters: false,
    savePlanBtn: false,
    quartersList: [],
    customPlanList: [
      {
        installment: 1,
        duedate: "",
        applydiscount: false,
        courseid: "",
        clientid: "",
        appid: "",
        amount: "",
        commission: "",
        commissionexcl: "",
        commissionincl: "",
        discount: "",
        discount_incl_gst: "",
        discount_excl_gst: "",
        duedate_error: "",
        amount_error: "",
        paymentdate_error: "",
        bonus_error: "",
      },
    ],
    paymentPlanText: "Add Payment Plan",
  });
}

cancelEdit(e) {
  e.preventDefault();
  this.setState({
    rowEdit: "",
    sEditCommission: "",
    sEditExcl: "",
    sEditIncl: "",
    sEditDiscount: "",
    sEditDiscountIncl: "",
    sEditDiscountExcl: "",
  });
}

// change status 
changeStatus(e, installmentId, courseid, newStatus) {
  e.preventDefault();
  
  if (newStatus === "discontinued" || newStatus === "paid") {
    swal({
      title: "Confirm Status Change",
      text: `Are you sure you want to change status to ${newStatus}?`,
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: true,
    }).then((willChange) => {
      if (willChange) {
        this._submitStatusChange(installmentId, courseid, newStatus);
      } else {
        this.props.parentCallback("getInstallments");
      }
    });
  } else {
    this._submitStatusChange(installmentId, courseid, newStatus);
  }
}

_submitStatusChange(installmentId, courseid, newStatus) {
  const data = {
    id: installmentId,
    status: newStatus,
    type: this.props.type,
    appid: this.props.appid,
    courseid: courseid,
  };
  
  let url = "changeInstallmentStatus";
  
  post_ApiManager(
    data,
    url,
    (res) => {
      console.log("status-changed", res);
      if (res.data.error) {
        swal(" ", res.data.error, "error");
        // Refresh to revert UI changes
        this.props.parentCallback("getInstallments");
      } else {
        swal("Success!", res.data.message, "success");
        // ✅ Refresh parent data
        this.props.parentCallback("getInstallments");
      }
    },
    (err) => {
      console.log(err);
      swal("Error", "Failed to update status", "error");
      // Refresh to revert UI changes
      this.props.parentCallback("getInstallments");
    }
  );
}
  render() {
    return (
      <>
        <Modal
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.props.show}
          onHide={() => this.handleModal()}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <div className="text-center col-lg-11 font-f-sans white">
              Commissions
            </div>
          </Modal.Header>
          <Modal.Body className="ml-2 mr-2">
            <form action="">
              {/* client info section */}
              <div className="row my-2">
                {/* Client ID */}
                <div className="form-group col-lg-3 d-flex pl-0">
                  <label className="profile-label pt-1">Client ID:</label>
                  <input
                    type="number"
                    className="form-control acc-form col-lg-8 ml-1"
                    disabled
                    value={this.props.clientDetail["clientid"]}
                  />
                </div>
                {/* Client Name */}
                <div className="form-group col-lg-4 d-flex pl-0">
                  <label className="profile-label pt-1">Client Name:</label>
                  <input
                    type="text"
                    className="form-control acc-form col-lg-8 ml-1"
                    disabled
                    value={this.props.clientDetail["clientname"]}
                  />
                </div>
                {/* Client Dob */}
                <div className="form-group col-lg-3 d-flex pl-0">
                  <label className="profile-label pt-1">DOB:</label>
                  <input
                    type="date"
                    className="date-input col-lg-9 ml-1"
                    name="dob"
                    onChange={this.handleChange}
                    defaultValue={this.props.clientDetail["clientdob"]}
                  />
                </div>

                <div className="col-2">
                  <button
                    className="btn btn-primary px-5"
                    onClick={(e) => this.saveDob(e)}
                  >
                    Save
                  </button>
                </div>
              </div>
              {/* Courses */}
              {this.props.courseDetail.map((v, k) => {
                  let installedSum = 0;
    if (v.installments) {
        v.installments.forEach(inst => {
            installedSum += parseFloat(inst.amount || 0);
        });
    }
    const totalFee = parseFloat(v.offered_fee || 0);
    const isFullyCovered = installedSum >= totalFee;
                return (
                  <>
                    <div className="border row" key={k}>
                      <h5 className="text-center bold font-f-monst-sans bg-white-smoke size-15 p-1 size-sm-12">
                        Course {++k}
                      </h5>
                      <div className="p-2 row">
                        <div className="my-2 d-flex">
                          {/* Course */}
                          <div className="form-group col-lg-6 d-flex pl-0">
                            <label className="profile-label pt-1">
                              Course:
                            </label>
                            <input
                              type="text"
                              className="form-control acc-form col-lg-10 ml-1"
                              disbaled
                              value={v.name}
                            />
                          </div>
                          <div className="form-group col-lg-3 d-flex pl-0">
                            <label className="profile-label pt-1">
                              Commence Date:
                            </label>
                            <input
                              type="date"
                              className="date-input col-lg-6 ml-1"
                              defaultValue={v.startdate}
                              onChange={(e) =>
                                this.setState({ newStartDate: e.target.value })
                              }
                            />
                          </div>
                          <div className="form-group col-lg-3 d-flex pl-0">
                            <label className="profile-label pt-1">
                              Finish Date:
                            </label>
                            <input
                              type="date"
                              className="date-input col-lg-6 ml-1"
                              defaultValue={v.enddate}
                              onChange={(e) =>
                                this.setState({ newEndDate: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        {/* Course Tution Fee */}
                        <div className="row">
                          <div className="form-group col-lg-4 d-flex pl-0">
                            <label className="profile-label pt-1">
                              Provider Name:
                            </label>
                            <input
                              type="text"
                              className="form-control acc-form col-lg-8 ml-1"
                              disbaled
                              value={v.providername}
                            />
                          </div>
                          {/* Course Tution Fee */}
                          <div className="form-group col-lg-3 d-flex pl-0">
                            <label className="profile-label pt-1">
                              Tution Fee:
                            </label>
                            <input
                              type="text"
                              defaultValue={v.offered_fee}
                              onChange={(e) =>
                                this.setState({ newFee: e.target.value })
                              }
                              className={`form-control acc-form mx-2 ${
                                this.state.newFee ||
                                this.state.newStartDate ||
                                this.state.newEndDate
                                  ? " col-lg-4 "
                                  : "col-lg-7"
                              }`}
                            />
                            {(this.state.newFee ||
                              this.state.newStartDate ||
                              this.state.newEndDate) && (
                              <div className="col-lg-1 d-flex pl-0">
                                <button
                                  className="btn btn-success"
                                  onClick={(e) => this.updateFee(e, v.courseid)}
                                >
                                  Update
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="form-group col-lg-2 d-flex pl-0">
                            <label className="profile-label pt-1">Bonus:</label>
                            <select
                              className="form-select app-form col-12"
                              name="bonus"
                              onChange={(e) =>
                                this.bonusValue(e, e.target.value, v.id)
                              }
                              value={v.app_bonus || ""}
                            >
                              <option value="">Please Select</option>

                              {v.bonus &&
                                v.bonus.length > 0 &&
                                v.bonus.map((bonusItem) => (
                                  <option
                                    value={bonusItem.bonus_amount}
                                    key={bonusItem.id}
                                  >
                                    {bonusItem.bonus_amount} AUD (
                                    {bonusItem.valid_from} to{" "}
                                    {bonusItem.valid_to})
                                  </option>
                                ))}

                              <option value="other">Other</option>
                            </select>
                          </div>

                          {/* when other option was selected then show that newbonus value */}
                          {v.app_bonus === "other" && (
                            <>
                              <div className="col-2 ml-5">
                                <input
                                  type="text"
                                  disabled
                                  placeholder="Enter bonus"
                                  className="form-control acc-form ml-4 col-7"
                                  value={"$" + v.new_app_bonus}
                                />
                              </div>
                            </>
                          )}
 {v.app_bonus === "other" && (
                            <>
                                {v.notes && (
      <div className="col-md-5 mb-2">
        <label className="font-weight-bold">Bonus Notes:</label>
        <textarea
          className="form-control"
          rows="2"
          value={v.notes}
          disabled
        />
      </div>
    )}
                            </>
                          )}

                        
                     
                        </div>

{/* <div className="card m">
                          {this.state.bonusId === "other" &&
                            this.state.appBonus == v.id && (
                              <div className={`col-2 ml-2`}>
                                <input
                                  type="number"
                                  onChange={(e) =>
                                    this.setState({ newBonus: e.target.value })
                                  }
                                  placeholder="Enter bonus"
                                  className="form-control acc-form ml-4 col-8"
                                />
                              </div>
                            )}
                          {this.state.bonusId &&
                            this.state.appBonus == v.id && (
                              <div
                                className={`col-2 ${
                                  this.state.bonusId === "other"
                                    ? " "
                                    : "text-right"
                                }`}
                              >
                                <button
                                  className="btn btn-success"
                                  onClick={(e) => this.saveBonus(e, v)}
                                >
                                  Save Bonus
                                </button>
                              </div>
                            )}
</div> */}


      {this.state.bonusId === "other" && this.state.appBonus === v.id && (
        <div className="card p-3">
  <div className="row align-items-start">

    {/* If "Other" selected → Bonus Input */}
    {this.state.bonusId === "other" &&
      this.state.appBonus === v.id && (
        <div className="col-md-3 mb-3">
          <input
            type="number"
            className="form-control"
            placeholder="Enter bonus"
            value={this.state.newBonus}
            onChange={(e) =>
              this.setState({ newBonus: e.target.value })
            }
          />
        </div>
      )}

    {/* Notes Textarea */}
    {this.state.bonusId &&
      this.state.appBonus === v.id && (
        <div className="col-md-4 mb-3">
          <textarea
            className="form-control"
            rows="3"
            placeholder="Enter notes"
            value={this.state.bonusNotes}
            onChange={(e) =>
              this.setState({ bonusNotes: e.target.value })
            }
          ></textarea>
        </div>
      )}

    {/* Buttons */}
    {this.state.bonusId &&
      this.state.appBonus === v.id && (
        <div className="col-md-3 mb-3">
          <button
            className="btn btn-success mr-2 ml-2"
            onClick={(e) => this.saveBonus(e, v)}
          >
            Save
          </button>

          <button
            className="btn btn-secondary"
            onClick={() =>
              this.setState({
                bonusId: "",
                newBonus: "",
                bonusNotes: "",
              })
            }
          >
            Cancel
          </button>
        </div>
      )}

  </div>
</div>
      )
}

   

                        {v.app_bonus &&
                          this.state.bonusCourse == "" &&
                          !v.bonusInstallments[0] && (
                            <div className="row mt-3">
                              <div className="col-12 text-center">
                                <button
                                  className="btn btn-primary px-5"
                                  onClick={(e) =>
                                    this.showBonusInstallment(e, v)
                                  }
                                >
                                  Bonus Installements
                                </button>
                              </div>
                            </div>
                          )}

                        {this.state.bonusInstallmentBtn == true &&
                          v.courseid == this.state.bonusCourse && (
                            <>
                              <div className="row p-2 border">
                                <h5 className="text-center bold font-f-monst-sans bg-white-smoke size-15 p-3 mt-1 pt-3 mb-0">
                                  Bonus Installement Plan
                                </h5>
                                {this.state.customBonusList.map((b, k) => {
                                  return (
                                    <div className="">
                                      <div
                                        className="row j-content-center p-3 border rounded"
                                        key={k}
                                      >
                                        {/* Installment no# */}
                                        <div className="form-group col-lg-2 pl-0">
                                          <div className="d-flex j-content-center">
                                            <label className="profile-label pt-1">
                                              Installment:
                                            </label>
                                            <input
                                              type="text"
                                              value={b.installment}
                                              className="form-control acc-form text-center col-5 ml-1"
                                              disabled
                                            />
                                          </div>
                                        </div>
                                        {/* Due date */}
                                        <div className="form-group col-lg-3 pl-0">
                                          <div className="d-flex j-content-center">
                                            <label className="profile-label pt-1">
                                              Due Date:
                                            </label>
                                            <input
                                              type="date"
                                              defaultValue={b.duedate}
                                              name="duedate"
                                              className="date-input col-8 ml-1"
                                              onChange={(e) =>
                                                this.handleCustomBonusInputChange(
                                                  e,
                                                  k
                                                )
                                              }
                                            />
                                          </div>
                                          {b.duedate_error && (
                                            <>
                                              <small className="error col-6">
                                                {b.duedate_error}
                                              </small>
                                            </>
                                          )}
                                        </div>
                                        {/* Amount */}
                                        <div className="form-group col-lg-3 pl-0">
                                          <div className="d-flex j-content-center">
                                            <label className="profile-label pt-1">
                                              Amount:
                                            </label>
                                            <input
                                              type="number"
                                              value={b.amount}
                                              name="amount"
                                              className="form-control acc-form col-8 ml-1"
                                              onChange={(e) =>
                                                this.handleCustomBonusInputChange(
                                                  e,
                                                  k,
                                                  v
                                                )
                                              }
                                            />
                                          </div>
                                          {b.amount_error && (
                                            <>
                                              <small className="error col-6">
                                                {b.amount_error}
                                              </small>
                                            </>
                                          )}
                                        </div>

                                        <div className="d-flex text-center j-content-center col-12 p-2">
                                          {this.state.customBonusList.length !==
                                            1 && (
                                            <button
                                              className="btn btn-danger mr-2"
                                              onClick={(e) =>
                                                this.handleCustomBonusRemoveClick(
                                                  e,
                                                  k
                                                )
                                              }
                                            >
                                              Remove Bonus Installment
                                            </button>
                                          )}
                                          {this.state.customBonusList.length -
                                            1 ===
                                            k && (
                                            <button
                                              className="btn btn-primary"
                                              onClick={(e) =>
                                                this.handleCustomBonusAddClick(
                                                  k,
                                                  e
                                                )
                                              }
                                            >
                                              Add More Bonus Installment
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                                <div className="mb-3">
                                  <label className="profile-label pt-1">
                                    Total Remaining Bonus:
                                  </label>
                                  <input
                                    type="number"
                                    value={this.state.remainingBonus}
                                    max="0.00"
                                    className="form-control acc-form col-3 ml-1"
                                    disabled
                                  />
                                </div>

                                {/* <div className="mb-3">
                                  <button
                                    className="btn btn-success col-12"
                                    onClick={(e) =>
                                      this.saveBonusInstallments(e)
                                    }
                                    disabled={this.state.savingInstallments}
                                  >
                                    Save Bonus Installments
                                  </button>
                                </div> */}

      <div className="d-flex mb-3 flex-row-reverse">
  <div className="col-4 me-3">
    <button
      className="btn btn-danger w-100"
      onClick={(e) => this.cancelBonusInstallment(e)}
    >
      Cancel
    </button>
  </div>

  <div className="col-4">
    <button
      className="btn btn-success w-100"
      onClick={(e) => this.saveBonusInstallments(e)}
      disabled={this.state.savingInstallments}
    >
      Save Bonus Installments
    </button>
  </div>
</div>

                                {v.id == this.state.bonusCourse && (
                                  <div className="col-4 my-2">
                                    <button
                                      className="btn btn-danger"
                                      onClick={(e) =>
                                        this.cancelBonusInstallment(e)
                                      }
                                    >
                                      Cancel Bonus Installments
                                    </button>
                                  </div>
                                )}
                              </div>
                            </>
                          )}

                        {/* Bonus installment Plans */}
                        {v.bonusInstallments && v.bonusInstallments[0] ? (
                          <div className="row mb-2">
                            <h5 className="text-center bold font-f-monst-sans bg-white-smoke size-16 p-3 mt-3 mb-0 pt-3">
                              Bonus
                            </h5>
                            <>
                              <table className="table table-bordered bg-white mb-1">
                                {/* Headers */}
                                <thead className="thead-dark">
                                  <tr>
                                    {this.state.bonusHeaders.map((head) => (
                                      <th
                                        id={head.field}
                                        key={head.field}
                                        className={head.align}
                                      >
                                        {head.name}
                                      </th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {v.bonusInstallments.map((x, index) => (
                                    <>
                                      <tr key={index}>
                                        <td className="text-center">
                                          {index + 1}
                                        </td>
                                        <td className="text-center name-text">
                                          {moment(x.duedate).format(
                                            "D MMM YYYY"
                                          )}
                                        </td>
                                        <td className="text-center name-text">
                                          {x.amount}
                                        </td>
                                        <td
                                          className={`text-center bold ${
                                            x.status == "pending"
                                              ? "text-red"
                                              : "text-c-green"
                                          }`}
                                        >
                                          {x.status == "pending"
                                            ? "Pending"
                                            : x.status == "paid"
                                            ? "Paid"
                                            : ""}
                                        </td>
                                        <td className="text-center w-15">
                                          {x.status == "pending" ? (
                                            <div className="row">
                                              {this.state
                                                .showBonusAddPaymentInput ==
                                                true &&
                                                this.state.bonusPaymentid ==
                                                  x.id && (
                                                  <>
                                                    <input
                                                      className="form-control acc-form col-lg-8 mb-2"
                                                      name="paymentAmount"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                    />
                                                    <input
                                                      type="date"
                                                      className="date-input text-center mb-2"
                                                      name="paymentDate"
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                    />
                                                    <button
                                                      className="btn btn-success mb-2"
                                                      onClick={(e) =>
                                                        this.saveBonusPayment(
                                                          e,
                                                          x.id,
                                                          x.amount
                                                        )
                                                      }
                                                    >
                                                      Save
                                                    </button>
                                                  </>
                                                )}

                                              {!this.state.bonusPaymentid ? (
                                                <button
                                                  className="btn btn-success"
                                                  onClick={(e) =>
                                                    this.makeBonusPayment(
                                                      e,
                                                      x.id
                                                    )
                                                  }
                                                >
                                                  Make Payment
                                                </button>
                                              ) : (
                                                this.state.bonusPaymentid ==
                                                  x.id && (
                                                  <button
                                                    className="btn btn-danger"
                                                    onClick={(e) =>
                                                      this.cancelPayment(
                                                        e,
                                                        x.id
                                                      )
                                                    }
                                                  >
                                                    Cancel
                                                  </button>
                                                )
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  ))}
                                </tbody>
                              </table>
                            </>
                            <div>
                              <button
                                className="btn btn-danger mt-2"
                                onClick={(e) =>
                                  this.deleteBonusInstallments(e, v.courseid)
                                }
                              >
                                Delete All Bonus Installements
                              </button>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        <div className="row my-3">
                          {v.installments && v.installments[0] ? (
                            <div className="row mb-3">
                              <h5 className="text-center bold font-f-monst-sans bg-white-smoke size-16 p-3 mb-0 pt-3">
                                Course Installments
                              </h5>
                               {/* {!isFullyCovered && (
                            <div className="col-12 text-end mt-3 mb-3">
                                <button
                                    className="btn btn-primary px-5"
                                    onClick={(e) => this.addPlan(e, v)}
                                >
                                    Add Remaining Payment Plan
                                </button>
                            </div>
                        )} */}

                        {!isFullyCovered && (
  <div className="col-12 text-end mt-3 mb-3">
    <div className="d-flex align-items-center justify-content-end gap-3">
     <div className="text-end">
  <span className="font-weight-bold text-primary">
    Remaining Amount:
  </span>
  <span className="font-weight-bold text-danger ml-2">
    ${(totalFee - installedSum).toFixed(2)}
  </span>
</div>
      <button
        className="btn btn-primary px-5"
        onClick={(e) => this.addPlan(e, v)}
      >
        Add Remaining Payment Plan
      </button>
    </div>
  </div>
)}

                              <>
                                <table className="table table-bordered bg-white mb-1">
                                  {/* Headers */}
                                  <thead className="thead-dark">
                                    <tr>
                                      {this.state.installmentsHeaders.map(
                                        (head) => (
                                          <th
                                            id={head.field}
                                            key={head.field}
                                            className={head.align}
                                          >
                                            {head.name}
                                          </th>
                                        )
                                      )}
                                    </tr>
                                  </thead>
                                  {/* End Headers */}
                                  <tbody>
                                    {v.installments.map((x, index) => (
                                      <>
                                        <tr key={index}>
                                          <td className="text-center">
                                            {x.installment_no}
                                          </td>
                                          <td className="text-center name-text">
                                            {moment(x.duedate).format(
                                              "D MMM YYYY"
                                            )}
                                          </td>
                                          <td className="text-center name-text">
                                            {x.amount}
                                          </td>
                                          <td className="text-center name-text">
                                            {x.id === this.state.rowEdit ? (
                                              <input
                                                type="number"
                                                defaultValue={
                                                  x.commission * 100
                                                }
                                                onChange={(e) =>
                                                  this.handleEditCommissionValue(
                                                    e,
                                                    x
                                                  )
                                                }
                                                className="form-control acc-form ml-1"
                                              />
                                            ) : (
                                              x.commission * 100
                                            )}{" "}
                                          </td>

                                          <td className="text-center">
                                            {x.id === this.state.rowEdit &&
                                            this.state.sEditIncl
                                              ? this.state.sEditIncl
                                              : x.commissionincl}
                                          </td>
                                          <td className="text-center">
                                            {x.id === this.state.rowEdit &&
                                            this.state.sEditExcl
                                              ? this.state.sEditExcl
                                              : x.commissionexcl}
                                          </td>

                                          <td className="text-center">
                                            {x.id === this.state.rowEdit ? (
                                              <input
                                                type="number"
                                                defaultValue={x.discount * 100}
                                                onChange={(e) =>
                                                  this.handleDiscountEditValue(
                                                    e,
                                                    x
                                                  )
                                                }
                                                className="form-control acc-form ml-1"
                                              />
                                            ) : x.discount ? (
                                              x.discount * 100
                                            ) : (
                                              0
                                            )}
                                          </td>

                                          <td className="text-center">
                                            {x.id === this.state.rowEdit &&
                                            this.state.sEditDiscountIncl
                                              ? this.state.sEditDiscountIncl
                                              : x.discount_incl_gst
                                              ? x.discount_incl_gst
                                              : "N/A"}
                                          </td>

                                          <td className="text-center">
                                            {x.id === this.state.rowEdit &&
                                            this.state.sEditDiscountExcl
                                              ? this.state.sEditDiscountExcl
                                              : x.discount_excl_gst
                                              ? x.discount_excl_gst
                                              : "N/A"}
                                          </td>

                                          <td className={`text-center`}>
                                            <div className="name-text">
                                              {x.remaining_amount}
                                            </div>
                                          </td>
                                         <td className="text-center fw-bold">
  <span
    className={
      x.status === "pending"
        ? "text-danger"
        : x.status === "paid"
        ? "text-success"
        : "text-secondary"
    }
  >
    {x.status === "pending"
      ? "Pending"
      : x.status === "paid"
      ? "Paid"
      : x.status || "—"}
  </span>
       {
        x.status === "pending" && (
            <select
      className="form-select form-select-sm border-danger text-danger fw-bold"
      style={{ minWidth: "70px" }}
      value={x.status}
      onChange={(e) => this.changeStatus(e, x.id, v.courseid, e.target.value)}
    >
      <option value="pending" disabled>Pending</option>
      <option value="discontinued">Discontinue</option>
    </select>
        )
       } 
  
</td>


     
                                          {/* Note Column */}
                                          <td className="text-center">
                                            <button
                                              className="btn btn-info"
                                              onClick={(e) =>
                                                this.showNote(e, x)
                                              }
                                            >
                                              Add Note
                                            </button>
                                            <br />
                                            {x.notes && (
                                              <small
                                                className="underline pointer heading-blue mt-1"
                                                onClick={(e) =>
                                                  this.showNoteDetails(e, x)
                                                }
                                              >
                                                Show Notes
                                              </small>
                                            )}
                                            <Modal
                                              aria-labelledby="contained-modal-title-vcenter"
                                              size="lg"
                                              centered
                                              show={this.state.showNoteDetail}
                                              onHide={() =>
                                                this.setState({
                                                  showNoteDetail: false,
                                                  noteDetail: "",
                                                })
                                              }
                                              backdrop="static"
                                              keyboard={false}
                                            >
                                              <Modal.Header closeButton>
                                                <div className="text-center col-11 font-f-sans white">
                                                  Notes
                                                </div>
                                              </Modal.Header>

                                              <Modal.Body className="ml-2">
                                                <div className="row">
                                                  <div className="col-2">
                                                    {" "}
                                                    <label className="profile-label pt-1">
                                                      Notes
                                                    </label>
                                                  </div>
                                                  <div className="col-10">
                                                    <div
                                                      className="acc-note pl-2 bold"
                                                      style={{
                                                        whiteSpace: "pre-wrap",
                                                      }}
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          DOMPurify.sanitize(
                                                            this.state
                                                              .noteDetail
                                                          ),
                                                      }}
                                                    ></div>
                                                  </div>
                                                </div>
                                              </Modal.Body>
                                              <Modal.Footer>
                                                <Button
                                                  className="btn btn-danger"
                                                  onClick={() =>
                                                    this.setState({
                                                      showNoteDetail: false,
                                                      noteDetail: "",
                                                    })
                                                  }
                                                >
                                                  {" "}
                                                  Close
                                                </Button>
                                              </Modal.Footer>
                                            </Modal>
                                            <Modals
                                              show={this.state.showNote}
                                              title={"Add Note"}
                                              type={"category"}
                                              textarea="true"
                                              noteType={false}
                                              parentCallback={
                                                this.handleNoteModelCallback
                                              }
                                            />
                                          </td>
                                          {/* Edit Option */}
                                          {/* <td className="text-center">
                                            <div className="d-flex gap-1">
                                              <button
                                                className="btn btn-primary"
                                                onClick={(e) =>
                                                  this.editRow(e, x)
                                                }
                                              >
                                                <FaIcons.FaRegEdit
                                                  size={15}
                                                  color={"#fffffff2"}
                                                />
                                              </button>
                                              <button
                                                className="btn btn-danger"
                                                onClick={(e) =>
                                                  this.deleteSingleInstallment(
                                                    e,
                                                    x.id,
                                                    v.courseid
                                                  )
                                                }
                                              >
                                                <FaIcons.FaTrash size={15} />
                                              </button>
                                            </div>
                                            {x.id === this.state.rowEdit &&
                                              (this.state.sEditCommission ||
                                                this.state.sEditDiscount) && (
                                                <button
                                                  className="btn btn-success mt-2"
                                                  onClick={(e) =>
                                                    this.updateSingleRow(e)
                                                  }
                                                >
                                                  Save
                                                </button>
                                              )}
                                          </td> */}
                                          {/* Edit Option */}
<td className="text-center">
  <div className="d-flex gap-1">
    {x.id === this.state.rowEdit ? (
      <>
        {/* Show Cancel & Save when in edit mode */}
        <button
          className="btn btn-danger"
          onClick={(e) => this.cancelEdit(e)}
        >
          <FaIcons.FaTimes size={15} />
        </button>
        <button
          className="btn btn-success"
          onClick={(e) => this.updateSingleRow(e)}
        >
          <FaIcons.FaSave size={15} />
        </button>
      </>
    ) : (
      <>
        {/* Show Edit & Delete when not in edit mode */}
        <button
          className="btn btn-primary"
          onClick={(e) => this.editRow(e, x)}
        >
          <FaIcons.FaRegEdit size={15} color={"#fffffff2"} />
        </button>
        <button
          className="btn btn-danger"
          onClick={(e) =>
            this.deleteSingleInstallment(e, x.id, v.courseid)
          }
        >
          <FaIcons.FaTrash size={15} />
        </button>
  

      </>
    )}
  </div>
</td>
                                        </tr>
                                      </>
                                    ))}
                                  </tbody>
                                </table>
                              </>
                              <div className="d-flex justify-between">
                                {/* add payment and delete installment buttons */}
                                <div className="d-flex gap-2">
                                  <button
                                    className="btn btn-danger"
                                    onClick={(e) =>
                                      this.deleteInstallments(
                                        e,
                                        v.courseid,
                                        v.courseid
                                      )
                                    }
                                  >
                                    Delete All Installements
                                  </button>
                                  {!this.state.showAddPayment &&
                                    !this.state.savePlanBtn && (
                                      <button
                                        className="btn btn-success px-4"
                                        onClick={(e) => this.addPayment(e)}
                                      >
                                        Add Payment
                                      </button>
                                    )}
                                </div>
                                {/* payment history  */}
                                <button
                                  className="btn btn-info px-4"
                                  onClick={(e) =>
                                    this.getHistroy(e, v.courseid)
                                  }
                                >
                                  Payment History
                                </button>
                              </div>

                              {this.state.showHistroyBtn && (
                                <div className="row">
                                  <table
                                    id="table-cost"
                                    className="table table-bordered bg-white mb-1"
                                  >
                                    {/* Headers */}
                                    <thead className="thead-dark">
                                      <tr>
                                        {this.state.histroyHeaders.map(
                                          (head) => (
                                            <th
                                              id={head.field}
                                              key={head.field}
                                              className={head.align}
                                            >
                                              {head.name}
                                            </th>
                                          )
                                        )}
                                      </tr>
                                    </thead>
                                    {/* End Headers */}
                                    <tbody>
                                      {this.state.historyList.map((v, k) => (
                                        <tr key={v.id}>
                                          <td className="name-text text-center">
                                            {v.paymentdate}
                                          </td>
                                          <td className="text-center">
                                            {v.amount}
                                          </td>
                                          <td
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                            className={`text-center ${
                                              v.status === "active"
                                                ? "active"
                                                : "text-red"
                                            }`}
                                          >
                                            {v.status}
                                          </td>
                                          <td className="text-center">
                                            {" "}
                                            <button
                                              onClick={(e) =>
                                                this.handleDelete(e, v.courseid)
                                              }
                                              className="btn btn-danger pl-3 pr-3 p-0 m-1 mb-2"
                                            >
                                              <FaIcons.FaTrashAlt
                                                size={12}
                                                color={"#fffcfc"}
                                              />{" "}
                                            </button>
                                            <button
                                              disabled={!v.document_url}
                                              onClick={(e) => {
                                                e.preventDefault(); // explicit stop propagation
                                                e.stopPropagation();
                                                if (v.document_url) {
                                                  window.open(
                                                    v.document_url,
                                                    "_blank",
                                                    "noopener,noreferrer"
                                                  );
                                                }
                                              }}
                                              // onClick={() => window.open(v.document_url, "_blank")}
                                              //   onClick={(e) =>
                                              //     this.handleDelete(e, v.courseid)
                                              //   }
                                              className="btn btn-primary pl-3 pr-3 p-0 m-1 mb-2"
                                            >
                                              <FaIcons.FaEye
                                                size={12}
                                                color={"#fffcfc"}
                                              />{" "}
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                  <div className="d-flex j-content-right mb-3 pr-1">
                                    <div className="mt-1 pointer">
                                      {/* Export table to excel */}
                                      {/* <ReactHTMLTableToExcel
                id=""
                className="btn btn-primary py-0 px-2"
                table="table-cost"
                filename="Professional Cost"
                sheet="tablexls"
                buttonText={<FaIcons.FaDownload size={11} color={'rgb(255 255 255)'} />} /> */}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          ) : (
                            <>
                              {v.offered_fee && (
                                <div className="col-12 text-center">
                                  <button
                                    className="btn btn-primary px-5"
                                    onClick={(e) => this.addPlan(e, v)}
                                  >
                                    {this.state.paymentPlanText}
                                  </button>
                                </div>
                              )}
                            </>
                          )}

                          {/* Show Installements */}
                          {this.state.showAddPayment && (
                            <>
                              <div className="card border rounded shadow-sm p-4 mb-4">
                                <div className="row g-3">
                                  {/* Payment Date */}
                                  <div className="col-md-6 col-lg-3">
                                    <label className="profile-label mb-1">
                                      Payment Date:
                                    </label>
                                    <input
                                      type="date"
                                      name="paymentDate"
                                      onChange={this.handleChange}
                                      className="form-control"
                                      style={{ height: "42px" }}
                                    />
                                  </div>

                                  {/* Amount */}
                                  <div className="col-md-6 col-lg-3">
                                    <label className="profile-label mb-1">
                                      Amount:
                                    </label>
                                    <div
                                      className="input-group"
                                      style={{ height: "42px" }}
                                    >
                                      <input
                                        type="number"
                                        step="0.01"
                                        name="paymentAmount"
                                        onChange={this.handleChange}
                                        className="form-control"
                                        placeholder="Enter amount"
                                        style={{ height: "100%" }}
                                      />
                                      <span
                                        className="input-group-text"
                                        style={{ height: "100%" }}
                                      >
                                        {this.state.currency}
                                      </span>
                                    </div>
                                  </div>

                                  {/* Button (align right on desktop, full on mobile) */}
                                  <div className="col-md-12 col-lg-6 d-flex align-items-end justify-content-lg-end">
                                    <button
                                      onClick={(e) =>
                                        this.makePayment(e, v.courseid)
                                      }
                                      className="btn btn-success px-4 py-2 w-100 w-lg-auto"
                                      disabled={
                                        this.state.editLoading ||
                                        !this.state.paymentFile
                                      }
                                    >
                                      {this.state.editLoading ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                          />
                                          Saving...
                                        </>
                                      ) : (
                                        "Make Payment"
                                      )}
                                    </button>
                                  </div>

                                  {/* Receipt — Full-width, large drag & drop zone */}
                                  <div className="col-12">
                                    <label className="profile-label mb-2 d-block">
                                      Receipt (PDF, JPG, PNG, DOC/DOCX)
                                    </label>

                                    {this.state.paymentFile ? (
                                      <div className="d-flex align-items-center p-3 border rounded bg-light w-100">
                                        <div className="flex-grow-1 d-flex align-items-center">
                                          <span className="badge bg-secondary me-2">
                                            <FaIcons.FaFile />
                                          </span>
                                          <span
                                            className="text-truncate"
                                            title={this.state.paymentFile.name}
                                          >
                                            {this.state.paymentFile.name} (
                                            {(
                                              this.state.paymentFile.size / 1024
                                            ).toFixed(1)}{" "}
                                            KB)
                                          </span>
                                        </div>
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-danger ms-3"
                                          onClick={this.removeFile}
                                          title="Remove file"
                                        >
                                          <FaIcons.FaTrash /> Remove
                                        </button>
                                      </div>
                                    ) : (
                                      <div
                                        className={`d-flex flex-column align-items-center justify-content-center border-2 border-dashed rounded p-4 text-center ${
                                          this.state.fileDrag
                                            ? "border-primary bg-primary bg-opacity-10"
                                            : "border-gray"
                                        }`}
                                        style={{
                                          minHeight: "120px",
                                          cursor: "pointer",
                                          transition: "all 0.25s",
                                          backgroundColor: this.state.fileDrag
                                            ? "#e3f2fd"
                                            : "#fafafa",
                                        }}
                                        onDrop={this.handleFileDrop}
                                        onDragOver={this.handleFileDragOver}
                                        onDragLeave={this.handleFileDragLeave}
                                        onClick={() =>
                                          document
                                            .getElementById(
                                              "receipt-upload-input"
                                            )
                                            .click()
                                        }
                                      >
                                        <div className="mb-2">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            fill="currentColor"
                                            className="bi bi-cloud-arrow-up"
                                            viewBox="0 0 16 16"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M7.646 5.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2z"
                                            />
                                            <path d="M4.406 3.342A.75.75 0 0 1 5.25 3h5.5a.75.75 0 0 1 .74.628l.007.122c.027.536.246 1.04.603 1.432.36.395.85.68 1.406.813.27.066.537.114.797.146a.76.76 0 0 1 .576.882c-.012.164-.058.595-.324 1.012-.263.412-.735.825-1.398 1.048A2.75 2.75 0 0 1 9.75 10c-.25 0-.487-.015-.71-.043-.663-.084-1.135-.497-1.398-.909-.266-.417-.312-.848-.324-1.012a.76.76 0 0 1 .576-.882c.26-.032.527-.08.797-.146.556-.133 1.046-.418 1.406-.813.357-.392.576-.896.603-1.432.007-.122.013-.252.013-.382a.75.75 0 0 1 .75-.75z" />
                                          </svg>
                                        </div>
                                        <p className="mb-1 fw-medium">
                                          Drag & drop your receipt here
                                        </p>
                                        <p className="text-muted small mb-0">
                                          or click to browse files
                                        </p>
                                        <input
                                          type="file"
                                          id="receipt-upload-input"
                                          className="d-none"
                                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                          onChange={(e) => {
                                            const file = e.target.files[0];
                                            this.handleFileChange(file);
                                            e.target.value = ""; // allow re-selecting same file
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* <div
                                className="d-flex align-items-center w-100"
                                style={{ gap: "12px" }}
                              > */}
                              {/* Payment Date */}
                              {/* <div
                                  className="d-flex flex-column"
                                  style={{ minWidth: "140px" }}
                                >
                                  <label className="profile-label mb-1">
                                    Payment Date:
                                  </label>
                                  <input
                                    type="date"
                                    name="paymentDate"
                                    onChange={this.handleChange}
                                    className="form-control"
                                    style={{ height: "38px" }}
                                  />
                                </div> */}

                              {/* Amount */}
                              {/* <div
                                  className="d-flex flex-column"
                                  style={{ minWidth: "140px" }}
                                >
                                  <label className="profile-label mb-1">
                                    Amount:
                                  </label>
                                  <div className="d-flex align-items-center">
                                    <input
                                      type="number"
                                      step="0.01"
                                      name="paymentAmount"
                                      onChange={this.handleChange}
                                      className="form-control"
                                      style={{ height: "38px" }}
                                      placeholder="Enter"
                                    />
                                    <span className="ml-2">
                                      {this.state.currency}
                                    </span>
                                  </div>
                                </div> */}

                              {/* Receipt */}
                              {/* <div
                                  className="d-flex flex-column"
                                  style={{ minWidth: "160px" }}
                                >
                                  <label className="profile-label mb-1">
                                    Receipt:
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    style={{
                                      height: "38px",
                                      paddingTop: "6px",
                                    }}
                                    onChange={(e) => {
                                      const file = e.target.files[0];
                                      this.setState({ paymentFile: file });
                                    }}
                                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                  />
                                </div> */}

                              {/* Button (FIXED alignment with empty label) */}
                              {/* <div
                                  className="d-flex flex-column"
                                  style={{ minWidth: "140px" }}
                                >
                                  <label
                                    className="profile-label mb-1"
                                    style={{ visibility: "hidden" }}
                                  >
                                    Placeholder
                                  </label>
                                  <button
                                    onClick={(e) =>
                                      this.makePayment(e, v.courseid)
                                    }
                                    className="btn btn-success px-4"
                                    disabled={this.state.editLoading}
                                    style={{ height: "38px" }}
                                  >
                                    {this.state.editLoading
                                      ? "Saving..."
                                      : "Make Payment"}
                                  </button>
                                </div> */}
                              {/* </div> */}
                            </>
                          )}

                          {/* Make Plan */}
                          {this.state.makePlanBtn &&
                            this.state.courseid === v.courseid && (
                              <div className="row my-2">
                                <h5 className="text-center bold font-f-monst-sans bg-white-smoke size-16 p-3 mb-3 pt-3">
                                  Payment Plan
                                </h5>
                                <div className="col-lg-4">
                                  <label className="profile-label pt-1">
                                    Schedule Frequency:
                                  </label>
                                  <select
                                    className="form-select acc-form form-select-lg w-lg-90"
                                    name="frequency"
                                    value={this.state.frequency}
                                    onChange={this.handleChange}
                                  >
                                    <option selected>Please Select</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="fortnight">Fortnight</option>
                                    <option value="quarterly">Quarterly</option>
                                    <option value="halfyearly">
                                      Half Yearly
                                    </option>
                                    <option value="annual">Annual</option>
                                    <option value="custom">Custom</option>
                                  </select>
                                </div>

                                {this.state.frequency !== "custom" && (
                                  <>
                                    <div className="col-lg-4">
                                      <label className="profile-label pt-1">
                                        No of Installments:
                                      </label>
                                      <input
                                        type="number"
                                        placeholder="Please enter"
                                        min="0"
                                        max="10"
                                        className="form-control acc-form w-lg-90  ml-1"
                                        name="installments"
                                        onChange={this.handleChange}
                                      />
                                    </div>

                                    <div className="col-lg-4">
                                      <label className="profile-label pt-1">
                                        Start Date:
                                      </label>
                                      <input
                                        type="date"
                                        name="inst_startdate"
                                        className="date-input w-lg-90  ml-1"
                                        onChange={this.handleChange}
                                      />
                                    </div>
                                  </>
                                )}

                                {/* Plan button */}
                                 <div className="d-flex gap-2 flex-row-reverse">
      <button
        className="btn btn-success my-3 pl-5 pr-5"
        onClick={(e) => this.makePlan(e)}
      >
        Make Plan
      </button>
      <button
        className="btn btn-danger my-3 pl-5 pr-5"
        onClick={(e) => this.cancelMakePlan(e)}
      >
        Cancel
      </button>
    </div>
                               
                              </div>
                            )}
                          {/* Show Custom Plan */}
                          {this.state.showCustomPlan &&
                            v.courseid == this.state.courseid && (
                              <>
                                <div className="row p-2 border mt-2">
                                  <h5 className="text-center bold font-f-monst-sans bg-white-smoke size-15 p-3 mt-1 pt-3 mb-0">
                                    Installement Plan for{" "}
                                    {this.state.selectedCourse}
                                  </h5>
                                  {this.state.customPlanList.map((a, key) => {
                                    return (
                                      <div className="" key={key}>
                                        <div className="row j-content-center p-3 border rounded">
                                          {/* Installment no# */}
                                          <div className="form-group col-lg-2 pl-0">
                                            <div className="d-flex j-content-center">
                                              <label className="profile-label pt-1">
                                                Installment:
                                              </label>
                                              <input
                                                type="text"
                                                value={a.installment}
                                                className="form-control acc-form text-center col-5 ml-1"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                          {/* Due date */}
                                          <div className="form-group col-lg-3 pl-0">
                                            <div className="d-flex j-content-center">
                                              <label className="profile-label pt-1">
                                                Due Date:
                                              </label>
                                              <input
                                                type="date"
                                                defaultValue={a.duedate}
                                                name="duedate"
                                                className="date-input col-8 ml-1"
                                                onChange={(e) =>
                                                  this.handleCustomInputChange(
                                                    e,
                                                    key
                                                  )
                                                }
                                              />
                                            </div>
                                            {a.duedate_error && (
                                              <>
                                                <small className="error col-6">
                                                  {a.duedate_error}
                                                </small>
                                              </>
                                            )}
                                          </div>
                                          {/* Amount */}
                                          <div className="form-group col-lg-3 pl-0">
                                            <div className="d-flex j-content-center">
                                              <label className="profile-label pt-1">
                                                Amount:
                                              </label>
                                              <input
                                                type="number"
                                                value={a.amount}
                                                name="amount"
                                                className="form-control acc-form col-8 ml-1"
                                                onChange={(e) =>
                                                  this.handleCustomInputChange(
                                                    e,
                                                    key,
                                                    v
                                                  )
                                                }
                                              />
                                            </div>
                                            {a.amount_error && (
                                              <>
                                                <small className="error col-6">
                                                  {a.amount_error}
                                                </small>
                                              </>
                                            )}
                                          </div>
                                          {/* Commission % */}
                                          <div className="form-group col-lg-3 pl-0">
                                            <div className="d-flex j-content-center">
                                              <label className="profile-label pt-1">
                                                Commissions%:
                                              </label>
                                              {a.commissionEdit ? (
                                                <>
                                                  <div className="d-flex">
                                                    <input
                                                      type="text"
                                                      defaultValue={
                                                        a.commission * 100
                                                      }
                                                      onChange={(e) =>
                                                        this.handleCommissionValue(
                                                          e,
                                                          a,
                                                          key
                                                        )
                                                      }
                                                      className="form-control acc-form col-lg-5 text-center"
                                                    />
                                                    <button
                                                      className="btn btn-success col-6 ml-2"
                                                      onClick={(e) =>
                                                        this.handleCommissionChange(
                                                          e,
                                                          a,
                                                          key
                                                        )
                                                      }
                                                      disabled={
                                                        a.updatedCommissionValue
                                                          ? true
                                                          : false
                                                      }
                                                    >
                                                      {a.updatedCommissionValue
                                                        ? "Applied"
                                                        : "Apply"}
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  <input
                                                    type="text"
                                                    value={a.commission * 100}
                                                    className="form-control acc-form text-center col-6 ml-1"
                                                    disabled
                                                  />
                                                  <div className="mt-1">
                                                    <FaIcons.FaEdit
                                                      className="ml-1"
                                                      onClick={(e) =>
                                                        this.allowCommissionEdit(
                                                          e,
                                                          a
                                                        )
                                                      }
                                                      size={14}
                                                      color={"#4173ea"}
                                                    />
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          </div>
                                          {/* Commission Exl tax */}
                                          <div className="form-group col-lg-3 pl-0 mt-3">
                                            <div className="d-flex j-content-center">
                                              <label className="profile-label pt-1">
                                                Commissions Excl.Tax:
                                              </label>
                                              <input
                                                type="text"
                                                value={a.commissionexcl}
                                                className="form-control acc-form text-center col-4 ml-1"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                          {/* Commission Incl tax */}
                                          <div className="form-group col-lg-3 pl-0 mt-3">
                                            <div className="d-flex j-content-center">
                                              <label className="profile-label pt-1">
                                                Commissions Incl.Tax:
                                              </label>
                                              <input
                                                type="text"
                                                value={a.commissionincl}
                                                className="form-control acc-form text-center col-4 ml-1"
                                                disabled
                                              />
                                            </div>
                                          </div>
                                          {a.applydiscount == true && (
                                            <>
                                              {/* Discount */}
                                              <div className="form-group col-lg-3 pl-0 mt-3">
                                                <div className="d-flex j-content-center">
                                                  <label className="profile-label pt-1">
                                                    Discount%:
                                                  </label>
                                                  {a.discountEdit ? (
                                                    <>
                                                      <div className="d-flex">
                                                        <input
                                                          type="number"
                                                          min={0.3}
                                                          step={0.0}
                                                          defaultValue={
                                                            a.discount * 100
                                                          }
                                                          onChange={(e) =>
                                                            this.handleDiscountValue(
                                                              e,
                                                              a,
                                                              key
                                                            )
                                                          }
                                                          className="form-control acc-form col-lg-5 text-center"
                                                        />
                                                        <button
                                                          className="btn btn-success col-7 ml-1"
                                                          onClick={(e) =>
                                                            this.handleDiscountChange(
                                                              e,
                                                              a,
                                                              key
                                                            )
                                                          }
                                                          disabled={
                                                            a.updatedDiscountValue
                                                              ? true
                                                              : false
                                                          }
                                                        >
                                                          {a.updatedDiscountValue
                                                            ? "Applied"
                                                            : "Apply"}
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <input
                                                        type="number"
                                                        min="0"
                                                        max="1"
                                                        step="0.1"
                                                        value={a.discount * 100}
                                                        className="form-control acc-form col-5 ml-1"
                                                        disabled
                                                      />
                                                      <div className="mt-1">
                                                        <FaIcons.FaEdit
                                                          className="ml-1"
                                                          onClick={(e) =>
                                                            this.allowDiscountEdit(
                                                              e,
                                                              a
                                                            )
                                                          }
                                                          size={14}
                                                          color={"#4173ea"}
                                                        />
                                                      </div>
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                              {/* Discount Payabe */}
                                              <div className="form-group col-lg-2 pl-0 mt-3">
                                                <div className="d-flex j-content-center">
                                                  <label className="profile-label pt-1">
                                                    Discount Gst Incl:
                                                  </label>
                                                  <input
                                                    type="number"
                                                    value={a.discount_incl_gst}
                                                    max="0.00"
                                                    className="form-control acc-form col-6 ml-1"
                                                    disabled
                                                  />
                                                </div>
                                              </div>
                                              <div className="form-group col-lg-2 pl-0 mt-3">
                                                <div className="d-flex j-content-center">
                                                  <label className="profile-label pt-1">
                                                    Discount Gst excl:
                                                  </label>
                                                  <input
                                                    type="number"
                                                    value={a.discount_excl_gst}
                                                    max="0.00"
                                                    className="form-control acc-form col-6 ml-1"
                                                    disabled
                                                  />
                                                </div>
                                              </div>
                                            </>
                                          )}

                                          <div className="form-group col-lg-2 pl-0 mt-3 text-center">
                                            <button
                                              className={
                                                a.applydiscount == true
                                                  ? "btn btn-danger"
                                                  : "btn btn-info"
                                              }
                                              name="applydiscount"
                                              onClick={(e) =>
                                                this.handleCustomInputChange(
                                                  e,
                                                  key,
                                                  v
                                                )
                                              }
                                            >
                                              {a.applydiscount == true
                                                ? "Remove"
                                                : "Apply"}
                                            </button>
                                          </div>
                                        </div>
                                        <div className="d-flex text-center j-content-center col-12 p-2">
                                          {this.state.customPlanList.length !==
                                            1 && (
                                            <button
                                              className="btn btn-danger mr-2"
                                              onClick={(e) =>
                                                this.handleCustomRemoveClick(
                                                  e,
                                                  key
                                                )
                                              }
                                            >
                                              Remove Installment
                                            </button>
                                          )}
                                          {this.state.customPlanList.length -
                                            1 ===
                                            key && (
                                            <button
                                              className="btn btn-primary"
                                              onClick={(e) =>
                                                this.handleCustomAddClick(
                                                  key,
                                                  e
                                                )
                                              }
                                            >
                                              Add More Installment
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}

                                  <div className="mb-3">
                                    <label className="profile-label pt-1">
                                      Total Remaining:
                                    </label>
                                    <input
                                      type="number"
                                      value={this.state.remaining}
                                      max="0.00"
                                      className="form-control acc-form col-3 ml-1"
                                      disabled
                                    />
                                  </div>

                                  <div className="mb-3">
                                    <button
                                      className="btn btn-success col-12"
                                      onClick={(e) =>
                                        this.saveInstallments(e, v.courseid)
                                      }
                                      disabled={this.state.savingInstallments}
                                    >
                                      Save Installments
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}

                          {/* Show Installements */}
                          {this.state.showQuarters && (
                            <>
                              <div className="row px-2">
                                <h5 className="text-center bold font-f-monst-sans bg-white-smoke size-16 p-3 my-3 pt-3">
                                  Payment Plan
                                </h5>
                                <table className="table table-bordered bg-white mb-1">
                                  {/* Headers */}
                                  <thead className="thead-dark">
                                    <tr>
                                      {" "}
                                      {this.state.headers.map((head) => (
                                        <th
                                          id={head.field}
                                          key={head.field}
                                          className={head.align}
                                        >
                                          {head.name}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  {/* End Headers */}
                                  <tbody>
                                    {this.state.quartersList.map((x) => (
                                      <tr key={x.qtr}>
                                        <td className="text-center">{x.qtr}</td>
                                       <td className="name-text">
        {this.state.editingDueDateQtr === x.qtr ? (
          <div className="d-flex align-items-center">
            <input
              type="date"
              value={this.formatDateForInput(x.paymentdate)}
              name="paymentdate"
              className="date-input col-6 ml-1 form-control"
              onChange={(e) => this.handleDueDateChange(e, x)}
            />
           <button
        className="btn btn-success btn-sm ml-2"
        onClick={(e) => this.saveDueDate(e, x)}
      >
      <FaIcons.FaCheck />
      </button>
            <button
              className="btn btn-secondary btn-sm ml-1"
              onClick={() => this.setState({ editingDueDateQtr: null })}
            >
              <FaIcons.FaTimes />
            </button>
          </div>
        ) : (
          <div className="d-flex align-items-center">
            <span>{x.paymentdate}</span>
            <FaIcons.FaEdit
              onClick={() =>
                this.setState({
                  editingDueDateQtr: x.qtr, 
                })
              }
              size={14}
              color={"#4173ea"}
              className="ml-2 pointer"
            />
          </div>
        )}
      </td>
                                        <td className="text-center w-10">
                                          {x.amount}
                                        </td>
                                        <td className="text-center w-10">
                                          {this.state.commissionEdit ? (
                                            <>
                                              <div className="d-flex">
                                                <input
                                                  type="text"
                                                  defaultValue={
                                                    x.commission * 100
                                                  }
                                                  onChange={(e) =>
                                                    this.handleCommissionValue(
                                                      e,
                                                      x
                                                    )
                                                  }
                                                  className="form-control acc-form col-lg-5 text-center"
                                                />
                                                <button
                                                  className="btn btn-success col-5 ml-2"
                                                  onClick={(e) =>
                                                    this.handleCommissionChange(
                                                      e,
                                                      x
                                                    )
                                                  }
                                                  disabled={
                                                    x.updatedCommissionValue
                                                      ? true
                                                      : false
                                                  }
                                                >
                                                  {x.updatedCommissionValue
                                                    ? "Applied"
                                                    : "Apply"}
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              {x.commission * 100}{" "}
                                              <FaIcons.FaEdit
                                                onClick={() =>
                                                  this.setState({
                                                    commissionEdit: true,
                                                  })
                                                }
                                                size={14}
                                                color={"#4173ea"}
                                              />
                                            </>
                                          )}{" "}
                                        </td>
                                        <td className="text-center">
                                          {x.commissionexcl}
                                        </td>
                                        <td className="text-center">
                                          {x.commissionincl}
                                        </td>
                                        <td className="text-center">
                                          {x.applydiscount === false ? (
                                            <>
                                              <button
                                                className="btn btn-success"
                                                onClick={(e) =>
                                                  this.applyDiscount(x)
                                                }
                                              >
                                                Apply
                                              </button>
                                            </>
                                          ) : (
                                            <>
                                              {this.state.discountEdit ? (
                                                <>
                                                  <div className="d-flex">
                                                    <input
                                                      type="text"
                                                      defaultValue={
                                                        x.discount * 100
                                                      }
                                                      onChange={(e) =>
                                                        this.handleDiscountValue(
                                                          e,
                                                          x
                                                        )
                                                      }
                                                      className="form-control acc-form col-lg-5 text-center"
                                                    />
                                                    <button
                                                      className="btn btn-success col-6 ml-1"
                                                      onClick={(e) =>
                                                        this.handleDiscountChange(
                                                          e,
                                                          x
                                                        )
                                                      }
                                                      disabled={
                                                        x.updatedDiscountValue
                                                          ? true
                                                          : false
                                                      }
                                                    >
                                                      {x.updatedDiscountValue
                                                        ? "Applied"
                                                        : "Apply"}
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  {" "}
                                                  {x.discount * 100}{" "}
                                                  <FaIcons.FaEdit
                                                    onClick={() =>
                                                      this.setState({
                                                        discountEdit: true,
                                                      })
                                                    }
                                                    size={14}
                                                    color={"#4173ea"}
                                                  />
                                                </>
                                              )}
                                            </>
                                          )}
                                        </td>
                                        <td className="text-center">
                                          {x.discount_incl_gst
                                            ? x.discount_incl_gst
                                            : "N/A"}
                                        </td>
                                        <td className="text-center">
                                          {x.discount_excl_gst
                                            ? x.discount_excl_gst
                                            : "N/A"}
                                        </td>
                                        <td className="text-center">
                                          {x.status}
                                        </td>
                                        <td className="text-center">
                                          <button
                                            className="btn btn-info"
                                            onClick={(e) => this.showNote(e, x)}
                                          >
                                            Add Note
                                          </button>
                                          {x.notes && (
                                            <small
                                              className="underline pointer heading-blue mt-1"
                                              onClick={(e) =>
                                                this.showNoteDetails(e, x.id)
                                              }
                                            >
                                              Show Notes
                                            </small>
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </>
                          )}

                          {/* Add Payment Button */}
                          {this.state.savePlanBtn && (
                            <div className="col-lg-6 text-right j-content-center mb-2 mt-3">
                              <button
                                className="btn btn-success ml-2 pl-5 pr-5"
                                onClick={(e) => this.savePlan(e, v.courseid)}
                              >
                                Save Payment Plan
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
              {/* end client info section */}
            </form>
            <div className="mt-2">
              <small className="acc-label bold mt-3">
                Note:
                <br />
                (1) Please make sure application location is selected.
                <br />
                (2) Course level and value of commission is given in provider.
                <br />
                (3) Tution fee of course is given.
              </small>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-danger"
              onClick={() => this.handleModal()}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default withNavigation(AppsCommission);
